var _style, _defs, _defs2, _defs3, _defs4, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2000 2000",
    style: {
      enableBackground: "new 0 0 2000 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\n\t\t.st0{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#F01000;}\n\t\n\t\t.st1{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#EF1000;}\n\t\n\t\t.st2{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#EE1000;}\n\t\n\t\t.st3{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#ED1001;}\n\t\n\t\t.st4{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#EC1101;}\n\t\n\t\t.st5{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#EB1101;}\n\t\n\t\t.st6{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#EA1101;}\n\t\n\t\t.st7{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#E91101;}\n\t\n\t\t.st8{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#E91102;}\n\t\n\t\t.st9{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#E81102;}\n\t\n\t\t.st10{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#E71102;}\n\t\n\t\t.st11{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#E61102;}\n\t\n\t\t.st12{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#E51102;}\n\t\n\t\t.st13{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#E51202;}\n\t\n\t\t.st14{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#E41202;}\n\t\n\t\t.st15{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#E41203;}\n\t\n\t\t.st16{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#E31203;}\n\t\n\t\t.st17{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#E21203;}\n\t\n\t\t.st18{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#E11203;}\n\t\n\t\t.st19{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#E01203;}\n\t\n\t\t.st20{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#DF1204;}\n\t\n\t\t.st21{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#DE1204;}\n\t\n\t\t.st22{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#DD1304;}\n\t\n\t\t.st23{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#DC1304;}\n\t\n\t\t.st24{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#DB1304;}\n\t\n\t\t.st25{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#DA1305;}\n\t\n\t\t.st26{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#D91305;}\n\t\n\t\t.st27{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#D81305;}\n\t\n\t\t.st28{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#D71305;}\n\t\n\t\t.st29{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#D61405;}\n\t\n\t\t.st30{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#D61406;}\n\t\n\t\t.st31{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#D51406;}\n\t\n\t\t.st32{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#D41406;}\n\t\n\t\t.st33{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#D31406;}\n\t\n\t\t.st34{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#D21406;}\n\t\n\t\t.st35{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#D11406;}\n\t\n\t\t.st36{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#D11407;}\n\t\n\t\t.st37{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#D01407;}\n\t\n\t\t.st38{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#CF1407;}\n\t\n\t\t.st39{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#CF1507;}\n\t\n\t\t.st40{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#CE1507;}\n\t\n\t\t.st41{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#CD1507;}\n\t\n\t\t.st42{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#CC1508;}\n\t\n\t\t.st43{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#CB1508;}\n\t\n\t\t.st44{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#CA1508;}\n\t\n\t\t.st45{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#C91508;}\n\t\n\t\t.st46{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#C81508;}\n\t\n\t\t.st47{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#C81608;}\n\t\n\t\t.st48{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#C71609;}\n\t\n\t\t.st49{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#C61609;}\n\t\n\t\t.st50{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#C51609;}\n\t\n\t\t.st51{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#C41609;}\n\t\n\t\t.st52{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#C31609;}\n\t\n\t\t.st53{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#C3160A;}\n\t\n\t\t.st54{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#C2160A;}\n\t\n\t\t.st55{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#C1160A;}\n\t\n\t\t.st56{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#C0170A;}\n\t\n\t\t.st57{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#BF170A;}\n\t\n\t\t.st58{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#BE170A;}\n\t\n\t\t.st59{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#BE170B;}\n\t\n\t\t.st60{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#BD170B;}\n\t\n\t\t.st61{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#BC170B;}\n\t\n\t\t.st62{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#BB170B;}\n\t\n\t\t.st63{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#BA170B;}\n\t\n\t\t.st64{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#B9170C;}\n\t\n\t\t.st65{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#B9180C;}\n\t\n\t\t.st66{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#B8180C;}\n\t\n\t\t.st67{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#B7180C;}\n\t\n\t\t.st68{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#B6180C;}\n\t\n\t\t.st69{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#B5180C;}\n\t\n\t\t.st70{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#B4180D;}\n\t\n\t\t.st71{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#B3180D;}\n\t\n\t\t.st72{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#B2180D;}\n\t\n\t\t.st73{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#B2190D;}\n\t\n\t\t.st74{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#B1190D;}\n\t\n\t\t.st75{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#B0190D;}\n\t\n\t\t.st76{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#B0190E;}\n\t\n\t\t.st77{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#AF190E;}\n\t\n\t\t.st78{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#AE190E;}\n\t\n\t\t.st79{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#AD190E;}\n\t\n\t\t.st80{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#AC190E;}\n\t\n\t\t.st81{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#AB190E;}\n\t\n\t\t.st82{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#AB190F;}\n\t\n\t\t.st83{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#AA1A0F;}\n\t\n\t\t.st84{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#A91A0F;}\n\t\n\t\t.st85{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#A81A0F;}\n\t\n\t\t.st86{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#A71A0F;}\n\t\n\t\t.st87{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#A61A10;}\n\t\n\t\t.st88{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#A51A10;}\n\t\n\t\t.st89{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#A41A10;}\n\t\n\t\t.st90{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#A31B10;}\n\t\n\t\t.st91{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#A21B10;}\n\t\n\t\t.st92{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#A11B11;}\n\t\n\t\t.st93{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#A01B11;}\n\t\n\t\t.st94{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#9F1B11;}\n\t\n\t\t.st95{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#9E1B11;}\n\t\n\t\t.st96{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#9D1B11;}\n\t\n\t\t.st97{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#9D1B12;}\n\t\n\t\t.st98{clip-path:url(#SVGID_00000160183068135599300110000017435606307208641691_);fill-rule:evenodd;clip-rule:evenodd;fill:#9C1B12;}\n\t\n\t\t.st99{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#4D4D4D;}\n\t\n\t\t.st100{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#4E4E4E;}\n\t\n\t\t.st101{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#4F4F4F;}\n\t\n\t\t.st102{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#505050;}\n\t\n\t\t.st103{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#515151;}\n\t\n\t\t.st104{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#525252;}\n\t\n\t\t.st105{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#535353;}\n\t\n\t\t.st106{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#545454;}\n\t\n\t\t.st107{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#555555;}\n\t\n\t\t.st108{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#565656;}\n\t\n\t\t.st109{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#575757;}\n\t\n\t\t.st110{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#585858;}\n\t\n\t\t.st111{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#595959;}\n\t\n\t\t.st112{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#5A5A5A;}\n\t\n\t\t.st113{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#5B5B5B;}\n\t\n\t\t.st114{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#5C5C5C;}\n\t\n\t\t.st115{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#5D5D5D;}\n\t\n\t\t.st116{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#5E5E5E;}\n\t\n\t\t.st117{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#5F5F5F;}\n\t\n\t\t.st118{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#606060;}\n\t\n\t\t.st119{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#616161;}\n\t\n\t\t.st120{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#626262;}\n\t\n\t\t.st121{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#636363;}\n\t\n\t\t.st122{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#646464;}\n\t\n\t\t.st123{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#656565;}\n\t\n\t\t.st124{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#666666;}\n\t\n\t\t.st125{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#676767;}\n\t\n\t\t.st126{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#686868;}\n\t\n\t\t.st127{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#696969;}\n\t\n\t\t.st128{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#6A6A6A;}\n\t\n\t\t.st129{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#6B6B6B;}\n\t\n\t\t.st130{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#6C6C6C;}\n\t\n\t\t.st131{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#6D6D6D;}\n\t\n\t\t.st132{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#6E6E6E;}\n\t\n\t\t.st133{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#6F6F6F;}\n\t\n\t\t.st134{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#707070;}\n\t\n\t\t.st135{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#717171;}\n\t\n\t\t.st136{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#727272;}\n\t\n\t\t.st137{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#737373;}\n\t\n\t\t.st138{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#747474;}\n\t\n\t\t.st139{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#757575;}\n\t\n\t\t.st140{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#767676;}\n\t\n\t\t.st141{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#777777;}\n\t\n\t\t.st142{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#787878;}\n\t\n\t\t.st143{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#797979;}\n\t\n\t\t.st144{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#7A7A7A;}\n\t\n\t\t.st145{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#7B7B7B;}\n\t\n\t\t.st146{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#7C7C7C;}\n\t\n\t\t.st147{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#7D7D7D;}\n\t\n\t\t.st148{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#7E7E7E;}\n\t\n\t\t.st149{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#7F7F7F;}\n\t\n\t\t.st150{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#808080;}\n\t\n\t\t.st151{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#818181;}\n\t\n\t\t.st152{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#828282;}\n\t\n\t\t.st153{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#838383;}\n\t\n\t\t.st154{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#848484;}\n\t\n\t\t.st155{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#858585;}\n\t\n\t\t.st156{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#868686;}\n\t\n\t\t.st157{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#888888;}\n\t\n\t\t.st158{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#898989;}\n\t\n\t\t.st159{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#8A8A8A;}\n\t\n\t\t.st160{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#8B8B8B;}\n\t\n\t\t.st161{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#8C8C8C;}\n\t\n\t\t.st162{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#8E8E8E;}\n\t\n\t\t.st163{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#8F8F8F;}\n\t\n\t\t.st164{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#909090;}\n\t\n\t\t.st165{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#919191;}\n\t\n\t\t.st166{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#929292;}\n\t\n\t\t.st167{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#939393;}\n\t\n\t\t.st168{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#959595;}\n\t\n\t\t.st169{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#969696;}\n\t\n\t\t.st170{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#979797;}\n\t\n\t\t.st171{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#989898;}\n\t\n\t\t.st172{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#999999;}\n\t\n\t\t.st173{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#9A9A9A;}\n\t\n\t\t.st174{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#9C9C9C;}\n\t\n\t\t.st175{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#9D9D9D;}\n\t\n\t\t.st176{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#9E9E9E;}\n\t\n\t\t.st177{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#9F9F9F;}\n\t\n\t\t.st178{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#A0A0A0;}\n\t\n\t\t.st179{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#A2A2A2;}\n\t\n\t\t.st180{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#A3A3A3;}\n\t\n\t\t.st181{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#A4A4A4;}\n\t\n\t\t.st182{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#A5A5A5;}\n\t\n\t\t.st183{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#A6A6A6;}\n\t\n\t\t.st184{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#A7A7A7;}\n\t\n\t\t.st185{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#A9A9A9;}\n\t\n\t\t.st186{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#AAAAAA;}\n\t\n\t\t.st187{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#ABABAB;}\n\t\n\t\t.st188{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#ACACAC;}\n\t\n\t\t.st189{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#ADADAD;}\n\t\n\t\t.st190{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#AEAEAE;}\n\t\n\t\t.st191{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#B0B0B0;}\n\t\n\t\t.st192{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#B1B1B1;}\n\t\n\t\t.st193{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#B2B2B2;}\n\t\n\t\t.st194{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#B3B3B3;}\n\t\n\t\t.st195{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#B4B4B4;}\n\t\n\t\t.st196{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#B6B6B6;}\n\t\n\t\t.st197{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#B7B7B7;}\n\t\n\t\t.st198{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#B8B8B8;}\n\t\n\t\t.st199{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#B9B9B9;}\n\t\n\t\t.st200{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#BABABA;}\n\t\n\t\t.st201{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#BBBBBB;}\n\t\n\t\t.st202{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#BDBDBD;}\n\t\n\t\t.st203{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#BEBEBE;}\n\t\n\t\t.st204{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#BFBFBF;}\n\t\n\t\t.st205{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#C0C0C0;}\n\t\n\t\t.st206{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#C1C1C1;}\n\t\n\t\t.st207{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#C2C2C2;}\n\t\n\t\t.st208{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#C4C4C4;}\n\t\n\t\t.st209{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#C5C5C5;}\n\t\n\t\t.st210{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#C6C6C6;}\n\t\n\t\t.st211{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#C7C7C7;}\n\t\n\t\t.st212{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#C8C8C8;}\n\t\n\t\t.st213{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#CACACA;}\n\t\n\t\t.st214{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#CBCBCB;}\n\t\n\t\t.st215{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#CCCCCC;}\n\t\n\t\t.st216{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#CDCDCD;}\n\t\n\t\t.st217{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#CECECE;}\n\t\n\t\t.st218{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#CFCFCF;}\n\t\n\t\t.st219{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#D1D1D1;}\n\t\n\t\t.st220{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#D2D2D2;}\n\t\n\t\t.st221{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#D3D3D3;}\n\t\n\t\t.st222{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#D4D4D4;}\n\t\n\t\t.st223{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#D5D5D5;}\n\t\n\t\t.st224{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#D6D6D6;}\n\t\n\t\t.st225{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#D8D8D8;}\n\t\n\t\t.st226{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#D9D9D9;}\n\t\n\t\t.st227{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#DADADA;}\n\t\n\t\t.st228{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#DBDBDB;}\n\t\n\t\t.st229{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#DCDCDC;}\n\t\n\t\t.st230{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#DEDEDE;}\n\t\n\t\t.st231{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#DFDFDF;}\n\t\n\t\t.st232{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#E0E0E0;}\n\t\n\t\t.st233{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#E1E1E1;}\n\t\n\t\t.st234{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#E2E2E2;}\n\t\n\t\t.st235{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#E3E3E3;}\n\t\n\t\t.st236{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#E5E5E5;}\n\t\n\t\t.st237{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#E6E6E6;}\n\t\n\t\t.st238{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#E7E7E7;}\n\t\n\t\t.st239{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#E8E8E8;}\n\t\n\t\t.st240{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#E9E9E9;}\n\t\n\t\t.st241{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#EAEAEA;}\n\t\n\t\t.st242{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#ECECEC;}\n\t\n\t\t.st243{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#EDEDED;}\n\t\n\t\t.st244{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#EEEEEE;}\n\t\n\t\t.st245{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#EFEFEF;}\n\t\n\t\t.st246{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#EBEBEB;}\n\t\n\t\t.st247{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#E3E4E4;}\n\t\n\t\t.st248{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#E2E3E3;}\n\t\n\t\t.st249{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#DCDDDD;}\n\t\n\t\t.st250{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#DBDCDC;}\n\t\n\t\t.st251{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#DADBDB;}\n\t\n\t\t.st252{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#D9DADA;}\n\t\n\t\t.st253{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#D8D9D9;}\n\t\n\t\t.st254{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#D7D7D7;}\n\t\n\t\t.st255{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#D4D5D5;}\n\t\n\t\t.st256{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#D3D4D4;}\n\t\n\t\t.st257{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#D2D3D3;}\n\t\n\t\t.st258{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#D1D2D2;}\n\t\n\t\t.st259{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#D0D1D1;}\n\t\n\t\t.st260{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#CFD0D0;}\n\t\n\t\t.st261{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#CCCDCD;}\n\t\n\t\t.st262{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#CBCCCC;}\n\t\n\t\t.st263{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#CACBCB;}\n\t\n\t\t.st264{clip-path:url(#SVGID_00000073718003340952361310000010377219049693282206_);fill-rule:evenodd;clip-rule:evenodd;fill:#C9CACA;}\n\t\n\t\t.st265{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#9B1C12;}\n\t\n\t\t.st266{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#9C1C12;}\n\t\n\t\t.st267{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#9C1B12;}\n\t\n\t\t.st268{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#9D1B12;}\n\t\n\t\t.st269{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#9D1B11;}\n\t\n\t\t.st270{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#9E1B11;}\n\t\n\t\t.st271{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#9F1B11;}\n\t\n\t\t.st272{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#A01B11;}\n\t\n\t\t.st273{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#A11B11;}\n\t\n\t\t.st274{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#A21B10;}\n\t\n\t\t.st275{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#A31B10;}\n\t\n\t\t.st276{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#A41A10;}\n\t\n\t\t.st277{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#A51A10;}\n\t\n\t\t.st278{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#A61A10;}\n\t\n\t\t.st279{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#A71A0F;}\n\t\n\t\t.st280{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#A81A0F;}\n\t\n\t\t.st281{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#A91A0F;}\n\t\n\t\t.st282{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#AA1A0F;}\n\t\n\t\t.st283{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#AB190F;}\n\t\n\t\t.st284{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#AB190E;}\n\t\n\t\t.st285{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#AC190E;}\n\t\n\t\t.st286{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#AD190E;}\n\t\n\t\t.st287{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#AE190E;}\n\t\n\t\t.st288{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#AF190E;}\n\t\n\t\t.st289{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#B0190E;}\n\t\n\t\t.st290{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#B0190D;}\n\t\n\t\t.st291{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#B1190D;}\n\t\n\t\t.st292{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#B2190D;}\n\t\n\t\t.st293{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#B2180D;}\n\t\n\t\t.st294{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#B3180D;}\n\t\n\t\t.st295{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#B4180D;}\n\t\n\t\t.st296{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#B5180C;}\n\t\n\t\t.st297{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#B6180C;}\n\t\n\t\t.st298{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#B7180C;}\n\t\n\t\t.st299{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#B8180C;}\n\t\n\t\t.st300{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#B9180C;}\n\t\n\t\t.st301{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#B9170C;}\n\t\n\t\t.st302{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#BA170B;}\n\t\n\t\t.st303{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#BB170B;}\n\t\n\t\t.st304{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#BC170B;}\n\t\n\t\t.st305{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#BD170B;}\n\t\n\t\t.st306{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#BE170B;}\n\t\n\t\t.st307{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#BE170A;}\n\t\n\t\t.st308{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#BF170A;}\n\t\n\t\t.st309{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#C0170A;}\n\t\n\t\t.st310{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#C1160A;}\n\t\n\t\t.st311{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#C2160A;}\n\t\n\t\t.st312{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#C3160A;}\n\t\n\t\t.st313{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#C31609;}\n\t\n\t\t.st314{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#C41609;}\n\t\n\t\t.st315{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#C51609;}\n\t\n\t\t.st316{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#C61609;}\n\t\n\t\t.st317{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#C71609;}\n\t\n\t\t.st318{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#C81608;}\n\t\n\t\t.st319{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#C81508;}\n\t\n\t\t.st320{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#C91508;}\n\t\n\t\t.st321{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#CA1508;}\n\t\n\t\t.st322{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#CB1508;}\n\t\n\t\t.st323{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#CC1508;}\n\t\n\t\t.st324{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#CD1507;}\n\t\n\t\t.st325{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#CE1507;}\n\t\n\t\t.st326{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#CF1507;}\n\t\n\t\t.st327{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#CF1407;}\n\t\n\t\t.st328{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#D01407;}\n\t\n\t\t.st329{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#D11407;}\n\t\n\t\t.st330{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#D11406;}\n\t\n\t\t.st331{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#D21406;}\n\t\n\t\t.st332{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#D31406;}\n\t\n\t\t.st333{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#D41406;}\n\t\n\t\t.st334{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#D51406;}\n\t\n\t\t.st335{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#D61406;}\n\t\n\t\t.st336{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#D61405;}\n\t\n\t\t.st337{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#D71305;}\n\t\n\t\t.st338{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#D81305;}\n\t\n\t\t.st339{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#D91305;}\n\t\n\t\t.st340{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#DA1305;}\n\t\n\t\t.st341{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#DB1304;}\n\t\n\t\t.st342{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#DC1304;}\n\t\n\t\t.st343{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#DD1304;}\n\t\n\t\t.st344{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#DE1204;}\n\t\n\t\t.st345{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#DF1204;}\n\t\n\t\t.st346{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#E01203;}\n\t\n\t\t.st347{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#E11203;}\n\t\n\t\t.st348{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#E21203;}\n\t\n\t\t.st349{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#E31203;}\n\t\n\t\t.st350{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#E41203;}\n\t\n\t\t.st351{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#E41202;}\n\t\n\t\t.st352{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#E51202;}\n\t\n\t\t.st353{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#E51102;}\n\t\n\t\t.st354{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#E61102;}\n\t\n\t\t.st355{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#E71102;}\n\t\n\t\t.st356{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#E81102;}\n\t\n\t\t.st357{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#E91102;}\n\t\n\t\t.st358{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#E91101;}\n\t\n\t\t.st359{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#EA1101;}\n\t\n\t\t.st360{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#EB1101;}\n\t\n\t\t.st361{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#EC1101;}\n\t\n\t\t.st362{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#ED1001;}\n\t\n\t\t.st363{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#EE1000;}\n\t\n\t\t.st364{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#EF1000;}\n\t\n\t\t.st365{clip-path:url(#SVGID_00000084518746582004829820000008669901658456614044_);fill-rule:evenodd;clip-rule:evenodd;fill:#F01000;}\n\t\n\t\t.st366{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#C9CACA;}\n\t\n\t\t.st367{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#CACBCB;}\n\t\n\t\t.st368{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#CBCCCC;}\n\t\n\t\t.st369{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#CCCDCD;}\n\t\n\t\t.st370{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#CECECE;}\n\t\n\t\t.st371{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#CFD0D0;}\n\t\n\t\t.st372{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#D0D1D1;}\n\t\n\t\t.st373{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#D1D2D2;}\n\t\n\t\t.st374{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#D2D3D3;}\n\t\n\t\t.st375{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#D3D4D4;}\n\t\n\t\t.st376{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#D4D5D5;}\n\t\n\t\t.st377{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#D6D6D6;}\n\t\n\t\t.st378{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#D7D7D7;}\n\t\n\t\t.st379{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#D8D9D9;}\n\t\n\t\t.st380{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#D9DADA;}\n\t\n\t\t.st381{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#DADBDB;}\n\t\n\t\t.st382{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#DBDCDC;}\n\t\n\t\t.st383{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#DCDDDD;}\n\t\n\t\t.st384{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#DEDEDE;}\n\t\n\t\t.st385{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#DFDFDF;}\n\t\n\t\t.st386{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#E0E0E0;}\n\t\n\t\t.st387{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#E1E1E1;}\n\t\n\t\t.st388{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#E2E3E3;}\n\t\n\t\t.st389{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#E3E4E4;}\n\t\n\t\t.st390{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#E5E5E5;}\n\t\n\t\t.st391{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#E6E6E6;}\n\t\n\t\t.st392{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#E7E7E7;}\n\t\n\t\t.st393{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#E8E8E8;}\n\t\n\t\t.st394{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#E9E9E9;}\n\t\n\t\t.st395{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#EAEAEA;}\n\t\n\t\t.st396{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#EBEBEB;}\n\t\n\t\t.st397{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#EDEDED;}\n\t\n\t\t.st398{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#EEEEEE;}\n\t\n\t\t.st399{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#EFEFEF;}\n\t\n\t\t.st400{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#ECECEC;}\n\t\n\t\t.st401{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#E3E3E3;}\n\t\n\t\t.st402{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#E2E2E2;}\n\t\n\t\t.st403{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#DCDCDC;}\n\t\n\t\t.st404{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#DBDBDB;}\n\t\n\t\t.st405{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#DADADA;}\n\t\n\t\t.st406{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#D9D9D9;}\n\t\n\t\t.st407{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#D8D8D8;}\n\t\n\t\t.st408{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#D5D5D5;}\n\t\n\t\t.st409{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#D4D4D4;}\n\t\n\t\t.st410{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#D3D3D3;}\n\t\n\t\t.st411{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#D2D2D2;}\n\t\n\t\t.st412{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#D1D1D1;}\n\t\n\t\t.st413{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#CFCFCF;}\n\t\n\t\t.st414{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#CDCDCD;}\n\t\n\t\t.st415{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#CCCCCC;}\n\t\n\t\t.st416{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#CBCBCB;}\n\t\n\t\t.st417{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#CACACA;}\n\t\n\t\t.st418{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#C8C8C8;}\n\t\n\t\t.st419{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#C7C7C7;}\n\t\n\t\t.st420{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#C6C6C6;}\n\t\n\t\t.st421{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#C5C5C5;}\n\t\n\t\t.st422{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#C4C4C4;}\n\t\n\t\t.st423{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#C2C2C2;}\n\t\n\t\t.st424{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#C1C1C1;}\n\t\n\t\t.st425{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#C0C0C0;}\n\t\n\t\t.st426{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#BFBFBF;}\n\t\n\t\t.st427{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#BEBEBE;}\n\t\n\t\t.st428{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#BDBDBD;}\n\t\n\t\t.st429{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#BBBBBB;}\n\t\n\t\t.st430{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#BABABA;}\n\t\n\t\t.st431{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#B9B9B9;}\n\t\n\t\t.st432{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#B8B8B8;}\n\t\n\t\t.st433{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#B7B7B7;}\n\t\n\t\t.st434{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#B6B6B6;}\n\t\n\t\t.st435{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#B4B4B4;}\n\t\n\t\t.st436{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#B3B3B3;}\n\t\n\t\t.st437{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#B2B2B2;}\n\t\n\t\t.st438{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#B1B1B1;}\n\t\n\t\t.st439{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#B0B0B0;}\n\t\n\t\t.st440{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#AEAEAE;}\n\t\n\t\t.st441{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#ADADAD;}\n\t\n\t\t.st442{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#ACACAC;}\n\t\n\t\t.st443{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#ABABAB;}\n\t\n\t\t.st444{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#AAAAAA;}\n\t\n\t\t.st445{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#A9A9A9;}\n\t\n\t\t.st446{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#A7A7A7;}\n\t\n\t\t.st447{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#A6A6A6;}\n\t\n\t\t.st448{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#A5A5A5;}\n\t\n\t\t.st449{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#A4A4A4;}\n\t\n\t\t.st450{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#A3A3A3;}\n\t\n\t\t.st451{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#A2A2A2;}\n\t\n\t\t.st452{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#A0A0A0;}\n\t\n\t\t.st453{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#9F9F9F;}\n\t\n\t\t.st454{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#9E9E9E;}\n\t\n\t\t.st455{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#9D9D9D;}\n\t\n\t\t.st456{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#9C9C9C;}\n\t\n\t\t.st457{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#9A9A9A;}\n\t\n\t\t.st458{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#999999;}\n\t\n\t\t.st459{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#989898;}\n\t\n\t\t.st460{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#979797;}\n\t\n\t\t.st461{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#969696;}\n\t\n\t\t.st462{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#959595;}\n\t\n\t\t.st463{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#939393;}\n\t\n\t\t.st464{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#929292;}\n\t\n\t\t.st465{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#919191;}\n\t\n\t\t.st466{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#909090;}\n\t\n\t\t.st467{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#8F8F8F;}\n\t\n\t\t.st468{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#8E8E8E;}\n\t\n\t\t.st469{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#8C8C8C;}\n\t\n\t\t.st470{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#8B8B8B;}\n\t\n\t\t.st471{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#8A8A8A;}\n\t\n\t\t.st472{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#898989;}\n\t\n\t\t.st473{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#888888;}\n\t\n\t\t.st474{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#868686;}\n\t\n\t\t.st475{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#858585;}\n\t\n\t\t.st476{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#848484;}\n\t\n\t\t.st477{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#838383;}\n\t\n\t\t.st478{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#828282;}\n\t\n\t\t.st479{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#818181;}\n\t\n\t\t.st480{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#808080;}\n\t\n\t\t.st481{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#7F7F7F;}\n\t\n\t\t.st482{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#7E7E7E;}\n\t\n\t\t.st483{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#7D7D7D;}\n\t\n\t\t.st484{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#7C7C7C;}\n\t\n\t\t.st485{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#7B7B7B;}\n\t\n\t\t.st486{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#7A7A7A;}\n\t\n\t\t.st487{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#797979;}\n\t\n\t\t.st488{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#787878;}\n\t\n\t\t.st489{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#777777;}\n\t\n\t\t.st490{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#767676;}\n\t\n\t\t.st491{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#757575;}\n\t\n\t\t.st492{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#747474;}\n\t\n\t\t.st493{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#737373;}\n\t\n\t\t.st494{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#727272;}\n\t\n\t\t.st495{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#717171;}\n\t\n\t\t.st496{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#707070;}\n\t\n\t\t.st497{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#6F6F6F;}\n\t\n\t\t.st498{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#6E6E6E;}\n\t\n\t\t.st499{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#6D6D6D;}\n\t\n\t\t.st500{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#6C6C6C;}\n\t\n\t\t.st501{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#6B6B6B;}\n\t\n\t\t.st502{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#6A6A6A;}\n\t\n\t\t.st503{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#696969;}\n\t\n\t\t.st504{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#686868;}\n\t\n\t\t.st505{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#676767;}\n\t\n\t\t.st506{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#666666;}\n\t\n\t\t.st507{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#656565;}\n\t\n\t\t.st508{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#646464;}\n\t\n\t\t.st509{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#636363;}\n\t\n\t\t.st510{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#626262;}\n\t\n\t\t.st511{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#616161;}\n\t\n\t\t.st512{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#606060;}\n\t\n\t\t.st513{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#5F5F5F;}\n\t\n\t\t.st514{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#5E5E5E;}\n\t\n\t\t.st515{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#5D5D5D;}\n\t\n\t\t.st516{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#5C5C5C;}\n\t\n\t\t.st517{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#5B5B5B;}\n\t\n\t\t.st518{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#5A5A5A;}\n\t\n\t\t.st519{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#595959;}\n\t\n\t\t.st520{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#585858;}\n\t\n\t\t.st521{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#575757;}\n\t\n\t\t.st522{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#565656;}\n\t\n\t\t.st523{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#555555;}\n\t\n\t\t.st524{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#545454;}\n\t\n\t\t.st525{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#535353;}\n\t\n\t\t.st526{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#525252;}\n\t\n\t\t.st527{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#515151;}\n\t\n\t\t.st528{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#505050;}\n\t\n\t\t.st529{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#4F4F4F;}\n\t\n\t\t.st530{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#4E4E4E;}\n\t\n\t\t.st531{clip-path:url(#SVGID_00000141430606997216582810000008949903359319678879_);fill-rule:evenodd;clip-rule:evenodd;fill:#4D4D4D;}\n\t.st532{fill-rule:evenodd;clip-rule:evenodd;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M425.72,1424.47l-293.88,290.01h144.28l215.69-212.94l72.06-71.09l72.22-71.25l364-359.15l-0.48-0.49 L716.38,718.92H572.1l284.35,280.63L572.1,1280.03l-73.35,72.38L425.72,1424.47z M1323.22,538.94l-68.5,67.54l-253.98,250.75 v142.33l339.61-335.08l192.59-190.16l0,0l192.42-189.68h-144.28L1433.4,430.37l-73.03,71.9L1323.22,538.94z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000063617253433258971430000016626687173933489328_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F01000"
    },
    points: " 131.84,1714.8 131.2,1511.55 1728.74,1507.03 1729.39,1710.28  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F01000"
    },
    points: " 131.2,1514.14 131.2,1506.06 1728.74,1501.54 1728.74,1509.62  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EF1000"
    },
    points: " 131.2,1508.81 131.2,1500.57 1728.74,1496.05 1728.74,1504.28  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EF1000"
    },
    points: " 131.2,1503.31 131.2,1495.08 1728.74,1490.55 1728.74,1498.79  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EF1000"
    },
    points: " 131.2,1497.82 131.2,1489.75 1728.74,1485.22 1728.74,1493.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EE1000"
    },
    points: " 131.2,1492.33 131.2,1484.25 1728.74,1479.73 1728.74,1487.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EE1000"
    },
    points: " 131.2,1487 131.2,1478.76 1728.74,1474.23 1728.74,1482.48  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ED1001"
    },
    points: " 131.2,1481.5 131.2,1473.26 1728.58,1468.74 1728.74,1476.98  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ED1001"
    },
    points: " 131.2,1476.01 131.03,1467.93 1728.58,1463.41 1728.74,1471.49  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ED1001"
    },
    points: " 131.2,1470.52 131.03,1462.44 1728.58,1457.91 1728.58,1465.99  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EC1101"
    },
    points: " 131.03,1465.19 131.03,1456.94 1728.58,1452.42 1728.58,1460.66  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EC1101"
    },
    points: " 131.03,1459.69 131.03,1451.45 1728.58,1446.93 1728.58,1455.17  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EC1101"
    },
    points: " 131.03,1454.2 131.03,1446.12 1728.58,1441.6 1728.58,1449.68  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EB1101"
    },
    points: " 131.03,1448.71 131.03,1440.63 1728.58,1436.1 1728.58,1444.18  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EB1101"
    },
    points: " 131.03,1443.38 131.03,1435.14 1728.58,1430.61 1728.58,1438.85  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EA1101"
    },
    points: " 131.03,1437.88 131.03,1429.64 1728.58,1425.12 1728.58,1433.35  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EA1101"
    },
    points: " 131.03,1432.39 131.03,1424.31 1728.58,1419.79 1728.58,1427.86  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EA1101"
    },
    points: " 131.03,1426.89 131.03,1418.82 1728.58,1414.29 1728.58,1422.37  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E91101"
    },
    points: " 131.03,1421.56 131.03,1413.32 1728.42,1408.8 1728.58,1417.04  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E91101"
    },
    points: " 131.03,1416.07 130.87,1407.83 1728.42,1403.31 1728.42,1411.55  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E91102"
    },
    points: " 130.87,1410.58 130.87,1402.5 1728.42,1397.98 1728.42,1406.05  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E81102"
    },
    points: " 130.87,1405.09 130.87,1397 1728.42,1392.48 1728.42,1400.56  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E81102"
    },
    points: " 130.87,1399.75 130.87,1391.51 1728.42,1386.99 1728.42,1395.23  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E71102"
    },
    points: " 130.87,1394.26 130.87,1386.02 1728.42,1381.5 1728.42,1389.73  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E71102"
    },
    points: " 130.87,1388.77 130.87,1380.69 1728.42,1376.16 1728.42,1384.24  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E71102"
    },
    points: " 130.87,1383.27 130.87,1375.2 1728.42,1370.67 1728.42,1378.75  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E61102"
    },
    points: " 130.87,1377.94 130.87,1369.7 1728.42,1365.18 1728.42,1373.42  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E61102"
    },
    points: " 130.87,1372.45 130.87,1364.21 1728.42,1359.68 1728.42,1367.93  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E61102"
    },
    points: " 130.87,1366.95 130.87,1358.88 1728.26,1354.35 1728.42,1362.43  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E51102"
    },
    points: " 130.87,1361.46 130.71,1353.38 1728.26,1348.86 1728.42,1356.94  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E51202"
    },
    points: " 130.87,1356.13 130.71,1347.89 1728.26,1343.37 1728.26,1351.61  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E41202"
    },
    points: " 130.71,1350.64 130.71,1342.4 1728.26,1337.88 1728.26,1346.11  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E41203"
    },
    points: " 130.71,1345.14 130.71,1337.06 1728.26,1332.54 1728.26,1340.62  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E41203"
    },
    points: " 130.71,1339.65 130.71,1331.58 1728.26,1327.05 1728.26,1335.13  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E31203"
    },
    points: " 130.71,1334.32 130.71,1326.08 1728.26,1321.56 1728.26,1329.79  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E31203"
    },
    points: " 130.71,1328.83 130.71,1320.59 1728.26,1316.06 1728.26,1324.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E31203"
    },
    points: " 130.71,1323.33 130.71,1315.25 1728.26,1310.73 1728.26,1318.81  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E21203"
    },
    points: " 130.71,1317.84 130.71,1309.76 1728.26,1305.24 1728.26,1313.31  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E21203"
    },
    points: " 130.71,1312.51 130.71,1304.27 1728.26,1299.74 1728.26,1307.99  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E11203"
    },
    points: " 130.71,1307.01 130.71,1298.77 1728.09,1294.25 1728.26,1302.49  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E11203"
    },
    points: " 130.71,1301.52 130.55,1293.44 1728.09,1288.92 1728.09,1297  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E11203"
    },
    points: " 130.55,1296.03 130.55,1287.95 1728.09,1283.43 1728.09,1291.51  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E01203"
    },
    points: " 130.55,1290.7 130.55,1282.45 1728.09,1277.93 1728.09,1286.17  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E01203"
    },
    points: " 130.55,1285.2 130.55,1276.97 1728.09,1272.44 1728.09,1280.68  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E01203"
    },
    points: " 130.55,1279.71 130.55,1271.63 1728.09,1266.95 1728.09,1275.18  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DF1204"
    },
    points: " 130.55,1274.22 130.55,1266.14 1728.09,1261.62 1728.09,1269.69  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DF1204"
    },
    points: " 130.55,1268.88 130.55,1260.65 1728.09,1256.12 1728.09,1264.36  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DE1204"
    },
    points: " 130.55,1263.39 130.55,1255.15 1728.09,1250.63 1728.09,1258.87  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DE1204"
    },
    points: " 130.55,1257.9 130.55,1249.66 1728.09,1245.13 1728.09,1253.38  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DE1204"
    },
    points: " 130.55,1252.4 130.55,1244.33 1727.93,1239.8 1728.09,1247.88  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DD1304"
    },
    points: " 130.55,1247.08 130.39,1238.83 1727.93,1234.31 1727.93,1242.55  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DD1304"
    },
    points: " 130.55,1241.58 130.39,1233.34 1727.93,1228.82 1727.93,1237.06  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DD1304"
    },
    points: " 130.39,1236.09 130.39,1227.85 1727.93,1223.33 1727.93,1231.56  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DC1304"
    },
    points: " 130.39,1230.6 130.39,1222.51 1727.93,1218 1727.93,1226.07  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DC1304"
    },
    points: " 130.39,1225.26 130.39,1217.03 1727.93,1212.5 1727.93,1220.74  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DC1304"
    },
    points: " 130.39,1219.77 130.39,1211.53 1727.93,1207.01 1727.93,1215.25  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DB1304"
    },
    points: " 130.39,1214.28 130.39,1206.04 1727.93,1201.51 1727.93,1209.75  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DB1304"
    },
    points: " 130.39,1208.78 130.39,1200.71 1727.93,1196.18 1727.93,1204.26  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DA1305"
    },
    points: " 130.39,1203.45 130.39,1195.21 1727.93,1190.69 1727.93,1198.93  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DA1305"
    },
    points: " 130.39,1197.96 130.39,1189.72 1727.77,1185.19 1727.93,1193.44  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DA1305"
    },
    points: " 130.39,1192.46 130.39,1184.22 1727.77,1179.7 1727.93,1187.94  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D91305"
    },
    points: " 130.39,1186.97 130.22,1178.89 1727.77,1174.37 1727.77,1182.45  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D91305"
    },
    points: " 130.22,1181.64 130.22,1173.4 1727.77,1168.88 1727.77,1177.12  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D91305"
    },
    points: " 130.22,1176.15 130.22,1167.91 1727.77,1163.39 1727.77,1171.62  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D81305"
    },
    points: " 130.22,1170.66 130.22,1162.42 1727.77,1157.89 1727.77,1166.13  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D81305"
    },
    points: " 130.22,1165.16 130.22,1157.09 1727.77,1152.56 1727.77,1160.64  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D71305"
    },
    points: " 130.22,1159.83 130.22,1151.59 1727.77,1147.07 1727.77,1155.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D71305"
    },
    points: " 130.22,1154.34 130.22,1146.1 1727.77,1141.57 1727.77,1149.81  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D71305"
    },
    points: " 130.22,1148.84 130.22,1140.6 1727.77,1136.08 1727.77,1144.32  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D61405"
    },
    points: " 130.22,1143.35 130.22,1135.27 1727.77,1130.75 1727.77,1138.83  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D61405"
    },
    points: " 130.22,1138.02 130.22,1129.78 1727.61,1125.25 1727.77,1133.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D61406"
    },
    points: " 130.22,1132.53 130.06,1124.28 1727.61,1119.76 1727.61,1128  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D51406"
    },
    points: " 130.06,1127.03 130.06,1118.79 1727.61,1114.27 1727.61,1122.51  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D51406"
    },
    points: " 130.06,1121.54 130.06,1113.46 1727.61,1108.94 1727.61,1117.02  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D41406"
    },
    points: " 130.06,1116.21 130.06,1107.97 1727.61,1103.45 1727.61,1111.68  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D41406"
    },
    points: " 130.06,1110.71 130.06,1102.48 1727.61,1097.95 1727.61,1106.19  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D41406"
    },
    points: " 130.06,1105.22 130.06,1096.98 1727.61,1092.46 1727.61,1100.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D31406"
    },
    points: " 130.06,1099.73 130.06,1091.65 1727.61,1087.13 1727.61,1095.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D31406"
    },
    points: " 130.06,1094.39 130.06,1086.16 1727.61,1081.63 1727.61,1089.87  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D31406"
    },
    points: " 130.06,1088.9 130.06,1080.66 1727.61,1076.14 1727.61,1084.38  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D21406"
    },
    points: " 130.06,1083.41 130.06,1075.17 1727.45,1070.64 1727.61,1078.89  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D21406"
    },
    points: " 130.06,1077.91 129.9,1069.84 1727.45,1065.31 1727.61,1073.39  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D11406"
    },
    points: " 130.06,1072.59 129.9,1064.34 1727.45,1059.82 1727.45,1068.06  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D11407"
    },
    points: " 129.9,1067.09 129.9,1058.85 1727.45,1054.33 1727.45,1062.57  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D11407"
    },
    points: " 129.9,1061.6 129.9,1053.36 1727.45,1048.84 1727.45,1057.07  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D01407"
    },
    points: " 129.9,1056.11 129.9,1048.03 1727.45,1043.5 1727.45,1051.58  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D01407"
    },
    points: " 129.9,1050.77 129.9,1042.54 1727.45,1038.01 1727.45,1046.25  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D01407"
    },
    points: " 129.9,1045.28 129.9,1037.04 1727.45,1032.52 1727.45,1040.76  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CF1407"
    },
    points: " 129.9,1039.79 129.9,1031.55 1727.45,1027.02 1727.45,1035.26  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CF1507"
    },
    points: " 129.9,1034.29 129.9,1026.22 1727.45,1021.69 1727.45,1029.77  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CE1507"
    },
    points: " 129.9,1028.96 129.9,1020.72 1727.45,1016.2 1727.45,1024.44  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CE1507"
    },
    points: " 129.9,1023.47 129.9,1015.23 1727.29,1010.7 1727.45,1018.95  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CE1507"
    },
    points: " 129.9,1017.98 129.74,1009.73 1727.29,1005.21 1727.29,1013.45  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CD1507"
    },
    points: " 129.74,1012.48 129.74,1004.4 1727.29,999.88 1727.29,1007.96  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CD1507"
    },
    points: " 129.74,1007.15 129.74,998.91 1727.29,994.39 1727.29,1002.47  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CD1507"
    },
    points: " 129.74,1001.66 129.74,993.42 1727.29,988.9 1727.29,997.13  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CC1508"
    },
    points: " 129.74,996.17 129.74,987.92 1727.29,983.4 1727.29,991.64  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CC1508"
    },
    points: " 129.74,990.67 129.74,982.59 1727.29,978.07 1727.29,986.15  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CB1508"
    },
    points: " 129.74,985.18 129.74,977.1 1727.29,972.58 1727.29,980.65  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CB1508"
    },
    points: " 129.74,979.85 129.74,971.61 1727.29,967.08 1727.29,975.32  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CB1508"
    },
    points: " 129.74,974.35 129.74,966.11 1727.29,961.59 1727.29,969.83  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CA1508"
    },
    points: " 129.74,968.86 129.74,960.78 1727.13,956.26 1727.29,964.34  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CA1508"
    },
    points: " 129.74,963.37 129.58,955.29 1727.13,950.77 1727.29,958.85  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CA1508"
    },
    points: " 129.74,958.04 129.58,949.8 1727.13,945.27 1727.13,953.51  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C91508"
    },
    points: " 129.58,952.54 129.58,944.3 1727.13,939.78 1727.13,948.02  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C91508"
    },
    points: " 129.58,947.05 129.58,938.97 1727.13,934.45 1727.13,942.53  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C91508"
    },
    points: " 129.58,941.56 129.58,933.48 1727.13,928.96 1727.13,937.03  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C81508"
    },
    points: " 129.58,936.22 129.58,927.98 1727.13,923.46 1727.13,931.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C81608"
    },
    points: " 129.58,930.73 129.58,922.49 1727.13,917.97 1727.13,926.21  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C71609"
    },
    points: " 129.58,925.24 129.58,917.16 1727.13,912.64 1727.13,920.71  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C71609"
    },
    points: " 129.58,919.75 129.58,911.67 1727.13,907.14 1727.13,915.22  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C71609"
    },
    points: " 129.58,914.41 129.58,906.17 1727.13,901.65 1727.13,909.89  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C61609"
    },
    points: " 129.58,908.92 129.58,900.68 1726.96,896.16 1727.13,904.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C61609"
    },
    points: " 129.58,903.43 129.42,895.35 1726.96,890.83 1726.96,898.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C61609"
    },
    points: " 129.42,897.93 129.42,889.86 1726.96,885.33 1726.96,893.41  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C51609"
    },
    points: " 129.42,892.6 129.42,884.36 1726.96,879.84 1726.96,888.08  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C51609"
    },
    points: " 129.42,887.11 129.42,878.87 1726.96,874.35 1726.96,882.58  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C41609"
    },
    points: " 129.42,881.62 129.42,873.54 1726.96,869.01 1726.96,877.09  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C41609"
    },
    points: " 129.42,876.12 129.42,868.05 1726.96,863.52 1726.96,871.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C41609"
    },
    points: " 129.42,870.79 129.42,862.55 1726.96,858.03 1726.96,866.27  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C31609"
    },
    points: " 129.42,865.3 129.42,857.06 1726.96,852.53 1726.96,860.77  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C31609"
    },
    points: " 129.42,859.81 129.42,851.73 1726.96,847.2 1726.96,855.28  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C3160A"
    },
    points: " 129.42,854.31 129.42,846.23 1726.8,841.71 1726.96,849.79  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C2160A"
    },
    points: " 129.42,848.98 129.26,840.74 1726.8,836.22 1726.96,844.46  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C2160A"
    },
    points: " 129.42,843.49 129.26,835.25 1726.8,830.72 1726.8,838.96  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C1160A"
    },
    points: " 129.26,838 129.26,829.92 1726.8,825.39 1726.8,833.47  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C1160A"
    },
    points: " 129.26,832.5 129.26,824.42 1726.8,819.9 1726.8,827.98  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C1160A"
    },
    points: " 129.26,827.17 129.26,818.93 1726.8,814.41 1726.8,822.64  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C0170A"
    },
    points: " 129.26,821.68 129.26,813.44 1726.8,808.91 1726.8,817.15  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C0170A"
    },
    points: " 129.26,816.18 129.26,808.11 1726.8,803.58 1726.8,811.66  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C0170A"
    },
    points: " 129.26,810.69 129.26,802.61 1726.8,798.09 1726.8,806.17  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BF170A"
    },
    points: " 129.26,805.36 129.26,797.12 1726.8,792.59 1726.8,800.83  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BF170A"
    },
    points: " 129.26,799.87 129.26,791.63 1726.8,787.1 1726.8,795.34  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BE170A"
    },
    points: " 129.26,794.37 129.26,786.29 1726.64,781.77 1726.8,789.85  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BE170B"
    },
    points: " 129.26,788.88 129.09,780.8 1726.64,776.28 1726.64,784.35  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BE170B"
    },
    points: " 129.09,783.55 129.09,775.31 1726.64,770.78 1726.64,779.02  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BD170B"
    },
    points: " 129.09,778.05 129.09,769.81 1726.64,765.29 1726.64,773.53  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BD170B"
    },
    points: " 129.09,772.56 129.09,764.48 1726.64,759.96 1726.64,768.04  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BD170B"
    },
    points: " 129.09,767.07 129.09,758.99 1726.64,754.47 1726.64,762.54  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BC170B"
    },
    points: " 129.09,761.73 129.09,753.5 1726.64,748.97 1726.64,757.21  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BC170B"
    },
    points: " 129.09,756.24 129.09,748 1726.64,743.48 1726.64,751.72  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BB170B"
    },
    points: " 129.09,750.75 129.09,742.67 1726.64,737.98 1726.64,746.22  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BB170B"
    },
    points: " 129.09,745.26 129.09,737.18 1726.64,732.65 1726.64,740.73  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BB170B"
    },
    points: " 129.09,739.92 129.09,731.68 1726.48,727.16 1726.64,735.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BA170B"
    },
    points: " 129.09,734.43 128.93,726.19 1726.48,721.67 1726.64,729.91  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BA170B"
    },
    points: " 129.09,728.94 128.93,720.7 1726.48,716.17 1726.48,724.41  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BA170B"
    },
    points: " 128.93,723.45 128.93,715.37 1726.48,710.84 1726.48,718.92  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B9170C"
    },
    points: " 128.93,718.11 128.93,709.87 1726.48,705.35 1726.48,713.59  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B9180C"
    },
    points: " 128.93,712.62 128.93,704.38 1726.48,699.86 1726.48,708.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B8180C"
    },
    points: " 128.93,707.13 128.93,698.89 1726.48,694.36 1726.48,702.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B8180C"
    },
    points: " 128.93,701.63 128.93,693.56 1726.48,689.03 1726.48,697.11  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B8180C"
    },
    points: " 128.93,696.3 128.93,688.06 1726.48,683.54 1726.48,691.78  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B7180C"
    },
    points: " 128.93,690.81 128.93,682.57 1726.48,678.04 1726.48,686.28  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B7180C"
    },
    points: " 128.93,685.32 128.93,677.08 1726.48,672.55 1726.48,680.79  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B7180C"
    },
    points: " 128.93,679.82 128.93,671.74 1726.32,667.22 1726.48,675.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B6180C"
    },
    points: " 128.93,674.49 128.77,666.25 1726.32,661.73 1726.32,669.97  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B6180C"
    },
    points: " 128.77,669 128.77,660.76 1726.32,656.23 1726.32,664.47  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B6180C"
    },
    points: " 128.77,663.51 128.77,655.27 1726.32,650.74 1726.32,658.98  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B5180C"
    },
    points: " 128.77,658.01 128.77,649.93 1726.32,645.41 1726.32,653.49  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B5180C"
    },
    points: " 128.77,652.68 128.77,644.44 1726.32,639.92 1726.32,648.15  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B4180D"
    },
    points: " 128.77,647.19 128.77,638.95 1726.32,634.42 1726.32,642.66  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B4180D"
    },
    points: " 128.77,641.69 128.77,633.45 1726.32,628.93 1726.32,637.17  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B4180D"
    },
    points: " 128.77,636.2 128.77,628.12 1726.32,623.6 1726.32,631.68  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B3180D"
    },
    points: " 128.77,630.87 128.77,622.63 1726.32,618.1 1726.32,626.35  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B3180D"
    },
    points: " 128.77,625.38 128.77,617.13 1726.16,612.61 1726.32,620.85  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B3180D"
    },
    points: " 128.77,619.88 128.61,611.64 1726.16,607.12 1726.32,615.36  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B2180D"
    },
    points: " 128.77,614.39 128.61,606.31 1726.16,601.79 1726.16,609.87  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B2190D"
    },
    points: " 128.61,609.06 128.61,600.82 1726.16,596.3 1726.16,604.53  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B1190D"
    },
    points: " 128.61,603.57 128.61,595.32 1726.16,590.8 1726.16,599.04  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B1190D"
    },
    points: " 128.61,598.07 128.61,589.83 1726.16,585.31 1726.16,593.55  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B1190D"
    },
    points: " 128.61,592.58 128.61,584.5 1726.16,579.98 1726.16,588.05  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B0190D"
    },
    points: " 128.61,587.25 128.61,579.01 1726.16,574.48 1726.16,582.72  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B0190D"
    },
    points: " 128.61,581.75 128.61,573.51 1726.16,568.99 1726.16,577.23  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B0190E"
    },
    points: " 128.61,576.26 128.61,568.02 1726.16,563.5 1726.16,571.74  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AF190E"
    },
    points: " 128.61,570.77 128.61,562.69 1726.16,558.17 1726.16,566.24  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AF190E"
    },
    points: " 128.61,565.43 128.61,557.19 1726,552.67 1726.16,560.91  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AE190E"
    },
    points: " 128.61,559.94 128.45,551.7 1726,547.18 1726,555.42  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AE190E"
    },
    points: " 128.45,554.45 128.45,546.21 1726,541.68 1726,549.92  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AE190E"
    },
    points: " 128.45,548.96 128.45,540.88 1726,536.35 1726,544.43  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AD190E"
    },
    points: " 128.45,543.62 128.45,535.38 1726,530.86 1726,539.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AD190E"
    },
    points: " 128.45,538.13 128.45,529.89 1726,525.37 1726,533.61  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AD190E"
    },
    points: " 128.45,532.64 128.45,524.4 1726,519.87 1726,528.11  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AC190E"
    },
    points: " 128.45,527.14 128.45,519.07 1726,514.54 1726,522.62  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AC190E"
    },
    points: " 128.45,521.81 128.45,513.57 1726,509.05 1726,517.29  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AB190E"
    },
    points: " 128.45,516.32 128.45,508.08 1726,503.55 1726,511.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AB190F"
    },
    points: " 128.45,510.83 128.45,502.59 1725.84,498.06 1726,506.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AB190F"
    },
    points: " 128.45,505.33 128.29,497.25 1725.84,492.73 1725.84,500.81  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AA1A0F"
    },
    points: " 128.45,500 128.29,491.76 1725.84,487.24 1725.84,495.48  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AA1A0F"
    },
    points: " 128.29,494.51 128.29,486.27 1725.84,481.75 1725.84,489.98  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AA1A0F"
    },
    points: " 128.29,489.02 128.29,480.78 1725.84,476.25 1725.84,484.49  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A91A0F"
    },
    points: " 128.29,483.52 128.29,475.45 1725.84,470.92 1725.84,479  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A91A0F"
    },
    points: " 128.29,478.19 128.29,469.95 1725.84,465.43 1725.84,473.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A81A0F"
    },
    points: " 128.29,472.7 128.29,464.46 1725.84,459.93 1725.84,468.17  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A81A0F"
    },
    points: " 128.29,467.2 128.29,458.96 1725.84,454.44 1725.84,462.68  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A81A0F"
    },
    points: " 128.29,461.71 128.29,453.63 1725.84,449.11 1725.84,457.19  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A71A0F"
    },
    points: " 128.29,456.22 128.29,448.14 1725.67,443.62 1725.84,451.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A71A0F"
    },
    points: " 128.29,450.89 128.13,442.64 1725.67,438.12 1725.84,446.36  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A71A0F"
    },
    points: " 128.29,445.39 128.13,437.15 1725.67,432.63 1725.67,440.87  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A61A10"
    },
    points: " 128.13,439.9 128.13,431.82 1725.67,427.3 1725.67,435.38  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A61A10"
    },
    points: " 128.13,434.41 128.13,426.33 1725.67,421.81 1725.67,429.88  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A51A10"
    },
    points: " 128.13,429.07 128.13,420.83 1725.67,416.31 1725.67,424.55  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A51A10"
    },
    points: " 128.13,423.58 128.13,415.34 1725.67,410.82 1725.67,419.06  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A51A10"
    },
    points: " 128.13,418.09 128.13,410.01 1725.67,405.49 1725.67,413.57  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A41A10"
    },
    points: " 128.13,412.59 128.13,404.52 1725.67,399.99 1725.67,408.07  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A41A10"
    },
    points: " 128.13,407.26 128.13,399.02 1725.67,394.5 1725.67,402.74  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A41A10"
    },
    points: " 128.13,401.77 128.13,393.53 1725.67,389.01 1725.67,397.25  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A31B10"
    },
    points: " 128.13,396.28 128.13,388.2 1725.51,383.68 1725.67,391.76  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A31B10"
    },
    points: " 128.13,390.78 127.96,382.7 1725.51,378.18 1725.51,386.26  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A31B10"
    },
    points: " 127.96,385.45 127.96,377.21 1725.51,372.69 1725.51,380.93  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A21B10"
    },
    points: " 127.96,379.96 127.96,371.72 1725.51,367.2 1725.51,375.44  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A21B10"
    },
    points: " 127.96,374.47 127.96,366.39 1725.51,361.87 1725.51,369.94  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A11B11"
    },
    points: " 127.96,368.97 127.96,360.9 1725.51,356.37 1725.51,364.45  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A11B11"
    },
    points: " 127.96,363.64 127.96,355.4 1725.51,350.88 1725.51,359.12  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A11B11"
    },
    points: " 127.96,358.15 127.96,349.91 1725.51,345.38 1725.51,353.62  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A01B11"
    },
    points: " 127.96,352.65 127.96,344.58 1725.51,340.05 1725.51,348.13  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A01B11"
    },
    points: " 127.96,347.16 127.96,339.08 1725.51,334.56 1725.51,342.64  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A01B11"
    },
    points: " 127.96,341.83 127.96,333.59 1725.35,329.07 1725.51,337.31  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9F1B11"
    },
    points: " 127.96,336.34 127.8,328.1 1725.35,323.57 1725.51,331.81  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9F1B11"
    },
    points: " 127.96,330.85 127.8,322.77 1725.35,318.24 1725.35,326.32  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9E1B11"
    },
    points: " 127.8,325.35 127.8,317.27 1725.35,312.75 1725.35,320.83  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9E1B11"
    },
    points: " 127.8,320.02 127.8,311.78 1725.35,307.26 1725.35,315.49  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9E1B11"
    },
    points: " 127.8,314.53 127.8,306.29 1725.35,301.76 1725.35,310  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9D1B11"
    },
    points: " 127.8,309.03 127.8,300.96 1725.35,296.43 1725.35,304.51  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9D1B11"
    },
    points: " 127.8,303.54 127.8,295.46 1725.35,290.94 1725.35,299.02  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9D1B12"
    },
    points: " 127.8,298.21 127.8,289.97 1725.35,285.44 1725.35,293.68  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000063617253433258971430000016626687173933489328_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9C1B12"
    },
    points: " 127.8,292.72 127.8,288.68 1725.35,284.15 1725.35,288.19  "
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000016788490418805141990000000010006730919695499_",
    d: "M568.07,1568.75c26.98,20.52,55.25,39.1,84.98,55.58 c102.92,57.36,221.5,90.15,347.68,90.15c198.24,0,377.74-80.78,507.31-211.33c24.4-24.56,47.02-50.89,67.7-78.68 c-49.92,2.58-95,7.43-139.59,7.43c-111.16,111.97-265.29,181.11-435.42,181.11c-94.83,0-184.66-21.48-264.8-59.78 c-33.44-15.99-65.11-35.06-94.84-56.54L568.07,1568.75z M1000.73,385.94c117.62,0,227.48,33.12,320.71,90.48 c13.41,8.08,26.33,16.8,38.93,26.01l73.03-72.06c-12.76-9.69-25.85-18.9-39.26-27.79c-112.77-74.64-248-117.94-393.41-117.94 c-394.86,0-714.92,320.06-714.92,714.92c0,128.29,33.77,248.81,93.06,352.86c14.22,25.04,29.89,49.12,46.85,72.06l73.03-72.06 c-15.35-21.81-29.41-44.59-41.85-68.34c-44.59-85.14-69.8-181.92-69.8-284.52C387.11,660.59,661.77,385.94,1000.73,385.94 L1000.73,385.94z M1436.15,1431.9l-72.06-71.41l-241.86-239.6l-50.09-49.44l-71.41,70.44l58.33,57.68l227.97,224.74 C1340.5,1427.05,1388.16,1431.9,1436.15,1431.9L1436.15,1431.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057863401434062919540000017960657755586968231_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000016788490418805141990000000010006730919695499_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4D4D4D"
    },
    points: " 285.81,1714.48 285.81,1711.57 1575.74,1711.57 1575.74,1714.48  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4D4D4D"
    },
    points: " 285.81,1714.48 285.81,1706.08 1575.74,1706.08 1575.74,1714.48  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4E4E4E"
    },
    points: " 285.81,1708.82 285.81,1700.43 1575.74,1700.43 1575.74,1708.82  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4E4E4E"
    },
    points: " 285.81,1703.33 285.81,1694.93 1575.74,1694.93 1575.74,1703.33  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4F4F4F"
    },
    points: " 285.81,1697.68 285.81,1689.28 1575.74,1689.28 1575.74,1697.68  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4F4F4F"
    },
    points: " 285.81,1692.02 285.81,1683.78 1575.74,1683.78 1575.74,1692.02  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4F4F4F"
    },
    points: " 285.81,1686.53 285.81,1678.13 1575.74,1678.13 1575.74,1686.53  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#505050"
    },
    points: " 285.81,1680.87 285.81,1672.47 1575.74,1672.47 1575.74,1680.87  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#505050"
    },
    points: " 285.81,1675.38 285.81,1666.98 1575.74,1666.98 1575.74,1675.38  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#515151"
    },
    points: " 285.81,1669.73 285.81,1661.32 1575.74,1661.32 1575.74,1669.73  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#515151"
    },
    points: " 285.81,1664.23 285.81,1655.83 1575.74,1655.83 1575.74,1664.23  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#515151"
    },
    points: " 285.81,1658.58 285.81,1650.17 1575.74,1650.17 1575.74,1658.58  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#525252"
    },
    points: " 285.81,1652.92 285.81,1644.68 1575.74,1644.68 1575.74,1652.92  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#525252"
    },
    points: " 285.81,1647.43 285.81,1639.03 1575.74,1639.03 1575.74,1647.43  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#535353"
    },
    points: " 285.81,1641.78 285.81,1633.38 1575.74,1633.38 1575.74,1641.78  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#535353"
    },
    points: " 285.81,1636.28 285.81,1627.88 1575.74,1627.88 1575.74,1636.28  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#535353"
    },
    points: " 285.81,1630.63 285.81,1622.23 1575.74,1622.23 1575.74,1630.63  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#545454"
    },
    points: " 285.81,1625.13 285.81,1616.73 1575.74,1616.73 1575.74,1625.13  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#545454"
    },
    points: " 285.81,1619.48 285.81,1611.08 1575.74,1611.08 1575.74,1619.48  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#555555"
    },
    points: " 285.81,1613.82 285.81,1605.58 1575.74,1605.58 1575.74,1613.82  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#555555"
    },
    points: " 285.81,1608.33 285.81,1599.93 1575.74,1599.93 1575.74,1608.33  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#555555"
    },
    points: " 285.81,1602.67 285.81,1594.28 1575.74,1594.28 1575.74,1602.67  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#565656"
    },
    points: " 285.81,1597.19 285.81,1588.78 1575.74,1588.78 1575.74,1597.19  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#565656"
    },
    points: " 285.81,1591.53 285.81,1583.13 1575.74,1583.13 1575.74,1591.53  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#575757"
    },
    points: " 285.81,1586.04 285.81,1577.63 1575.74,1577.63 1575.74,1586.04  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#575757"
    },
    points: " 285.81,1580.38 285.81,1571.98 1575.74,1571.98 1575.74,1580.38  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#575757"
    },
    points: " 285.81,1574.73 285.81,1566.48 1575.74,1566.48 1575.74,1574.73  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#585858"
    },
    points: " 285.81,1569.23 285.81,1560.83 1575.74,1560.83 1575.74,1569.23  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#585858"
    },
    points: " 285.81,1563.58 285.81,1555.18 1575.74,1555.18 1575.74,1563.58  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#595959"
    },
    points: " 285.81,1558.08 285.81,1549.69 1575.74,1549.69 1575.74,1558.08  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#595959"
    },
    points: " 285.81,1552.43 285.81,1544.03 1575.74,1544.03 1575.74,1552.43  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#595959"
    },
    points: " 285.81,1546.94 285.81,1538.54 1575.74,1538.54 1575.74,1546.94  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5A5A5A"
    },
    points: " 285.81,1541.28 285.81,1532.88 1575.74,1532.88 1575.74,1541.28  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5A5A5A"
    },
    points: " 285.81,1535.63 285.81,1527.39 1575.74,1527.39 1575.74,1535.63  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5B5B5B"
    },
    points: " 285.81,1530.13 285.81,1521.73 1575.74,1521.73 1575.74,1530.13  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5B5B5B"
    },
    points: " 285.81,1524.48 285.81,1516.08 1575.74,1516.08 1575.74,1524.48  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5B5B5B"
    },
    points: " 285.81,1518.99 285.81,1510.58 1575.74,1510.58 1575.74,1518.99  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5C5C5C"
    },
    points: " 285.81,1513.33 285.81,1504.93 1575.74,1504.93 1575.74,1513.33  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5C5C5C"
    },
    points: " 285.81,1507.84 285.81,1499.43 1575.74,1499.43 1575.74,1507.84  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5D5D5D"
    },
    points: " 285.81,1502.18 285.81,1493.78 1575.74,1493.78 1575.74,1502.18  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5D5D5D"
    },
    points: " 285.81,1496.53 285.81,1488.29 1575.74,1488.29 1575.74,1496.53  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5D5D5D"
    },
    points: " 285.81,1491.04 285.81,1482.64 1575.74,1482.64 1575.74,1491.04  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5E5E5E"
    },
    points: " 285.81,1485.38 285.81,1476.98 1575.74,1476.98 1575.74,1485.38  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5E5E5E"
    },
    points: " 285.81,1479.89 285.81,1471.49 1575.74,1471.49 1575.74,1479.89  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5F5F5F"
    },
    points: " 285.81,1474.23 285.81,1465.83 1575.74,1465.83 1575.74,1474.23  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5F5F5F"
    },
    points: " 285.81,1468.74 285.81,1460.34 1575.74,1460.34 1575.74,1468.74  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5F5F5F"
    },
    points: " 285.81,1463.08 285.81,1454.68 1575.74,1454.68 1575.74,1463.08  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#606060"
    },
    points: " 285.81,1457.43 285.81,1449.19 1575.74,1449.19 1575.74,1457.43  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#606060"
    },
    points: " 285.81,1451.94 285.81,1443.54 1575.74,1443.54 1575.74,1451.94  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#616161"
    },
    points: " 285.81,1446.29 285.81,1437.88 1575.74,1437.88 1575.74,1446.29  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#616161"
    },
    points: " 285.81,1440.79 285.81,1432.39 1575.74,1432.39 1575.74,1440.79  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#616161"
    },
    points: " 285.81,1435.14 285.81,1426.73 1575.74,1426.73 1575.74,1435.14  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#626262"
    },
    points: " 285.81,1429.64 285.81,1421.24 1575.74,1421.24 1575.74,1429.64  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#626262"
    },
    points: " 285.81,1423.99 285.81,1415.58 1575.74,1415.58 1575.74,1423.99  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#636363"
    },
    points: " 285.81,1418.33 285.81,1410.09 1575.74,1410.09 1575.74,1418.33  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#636363"
    },
    points: " 285.81,1412.84 285.81,1404.44 1575.74,1404.44 1575.74,1412.84  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#636363"
    },
    points: " 285.81,1407.18 285.81,1398.78 1575.74,1398.78 1575.74,1407.18  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#646464"
    },
    points: " 285.81,1401.69 285.81,1393.29 1575.74,1393.29 1575.74,1401.69  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#646464"
    },
    points: " 285.81,1396.03 285.81,1387.64 1575.74,1387.64 1575.74,1396.03  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#656565"
    },
    points: " 285.81,1390.54 285.81,1382.14 1575.74,1382.14 1575.74,1390.54  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#656565"
    },
    points: " 285.81,1384.89 285.81,1376.49 1575.74,1376.49 1575.74,1384.89  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#656565"
    },
    points: " 285.81,1379.23 285.81,1370.99 1575.74,1370.99 1575.74,1379.23  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#666666"
    },
    points: " 285.81,1373.74 285.81,1365.34 1575.74,1365.34 1575.74,1373.74  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#666666"
    },
    points: " 285.81,1368.09 285.81,1359.84 1575.74,1359.84 1575.74,1368.09  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#676767"
    },
    points: " 285.81,1362.59 285.81,1354.19 1575.74,1354.19 1575.74,1362.59  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#676767"
    },
    points: " 285.81,1356.94 285.81,1348.53 1575.74,1348.53 1575.74,1356.94  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#676767"
    },
    points: " 285.81,1351.44 285.81,1343.04 1575.74,1343.04 1575.74,1351.44  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#686868"
    },
    points: " 285.81,1345.79 285.81,1337.39 1575.74,1337.39 1575.74,1345.79  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#686868"
    },
    points: " 285.81,1340.3 285.81,1331.9 1575.74,1331.9 1575.74,1340.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#696969"
    },
    points: " 285.81,1334.64 285.81,1326.24 1575.74,1326.24 1575.74,1334.64  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#696969"
    },
    points: " 285.81,1328.99 285.81,1320.75 1575.74,1320.75 1575.74,1328.99  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#696969"
    },
    points: " 285.81,1323.49 285.81,1315.09 1575.74,1315.09 1575.74,1323.49  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6A6A6A"
    },
    points: " 285.81,1317.84 285.81,1309.44 1575.74,1309.44 1575.74,1317.84  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6A6A6A"
    },
    points: " 285.81,1312.34 285.81,1303.94 1575.74,1303.94 1575.74,1312.34  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6B6B6B"
    },
    points: " 285.81,1306.69 285.81,1298.29 1575.74,1298.29 1575.74,1306.69  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6B6B6B"
    },
    points: " 285.81,1301.2 285.81,1292.8 1575.74,1292.8 1575.74,1301.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6B6B6B"
    },
    points: " 285.81,1295.55 285.81,1287.14 1575.74,1287.14 1575.74,1295.55  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6C6C6C"
    },
    points: " 285.81,1289.89 285.81,1281.65 1575.74,1281.65 1575.74,1289.89  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6C6C6C"
    },
    points: " 285.81,1284.4 285.81,1275.99 1575.74,1275.99 1575.74,1284.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6D6D6D"
    },
    points: " 285.81,1278.74 285.81,1270.34 1575.74,1270.34 1575.74,1278.74  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6D6D6D"
    },
    points: " 285.81,1273.25 285.81,1264.84 1575.74,1264.84 1575.74,1273.25  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6D6D6D"
    },
    points: " 285.81,1267.59 285.81,1259.19 1575.74,1259.19 1575.74,1267.59  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6E6E6E"
    },
    points: " 285.81,1262.1 285.81,1253.7 1575.74,1253.7 1575.74,1262.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6E6E6E"
    },
    points: " 285.81,1256.44 285.81,1248.04 1575.74,1248.04 1575.74,1256.44  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6F6F6F"
    },
    points: " 285.81,1250.79 285.81,1242.55 1575.74,1242.55 1575.74,1250.79  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6F6F6F"
    },
    points: " 285.81,1245.29 285.81,1236.9 1575.74,1236.9 1575.74,1245.29  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6F6F6F"
    },
    points: " 285.81,1239.64 285.81,1231.24 1575.74,1231.24 1575.74,1239.64  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#707070"
    },
    points: " 285.81,1234.15 285.81,1225.75 1575.74,1225.75 1575.74,1234.15  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#707070"
    },
    points: " 285.81,1228.49 285.81,1220.09 1575.74,1220.09 1575.74,1228.49  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#717171"
    },
    points: " 285.81,1223 285.81,1214.6 1575.74,1214.6 1575.74,1223  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#717171"
    },
    points: " 285.81,1217.35 285.81,1208.94 1575.74,1208.94 1575.74,1217.35  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#717171"
    },
    points: " 285.81,1211.69 285.81,1203.45 1575.74,1203.45 1575.74,1211.69  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727272"
    },
    points: " 285.81,1206.2 285.81,1197.79 1575.74,1197.79 1575.74,1206.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727272"
    },
    points: " 285.81,1200.54 285.81,1192.14 1575.74,1192.14 1575.74,1200.54  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#737373"
    },
    points: " 285.81,1195.05 285.81,1186.65 1575.74,1186.65 1575.74,1195.05  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#737373"
    },
    points: " 285.81,1189.4 285.81,1181 1575.74,1181 1575.74,1189.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#737373"
    },
    points: " 285.81,1183.9 285.81,1175.5 1575.74,1175.5 1575.74,1183.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#747474"
    },
    points: " 285.81,1178.25 285.81,1169.85 1575.74,1169.85 1575.74,1178.25  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#747474"
    },
    points: " 285.81,1172.59 285.81,1164.35 1575.74,1164.35 1575.74,1172.59  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#757575"
    },
    points: " 285.81,1167.1 285.81,1158.7 1575.74,1158.7 1575.74,1167.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#757575"
    },
    points: " 285.81,1161.44 285.81,1153.04 1575.74,1153.04 1575.74,1161.44  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#757575"
    },
    points: " 285.81,1155.95 285.81,1147.55 1575.74,1147.55 1575.74,1155.95  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#767676"
    },
    points: " 285.81,1150.29 285.81,1141.89 1575.74,1141.89 1575.74,1150.29  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#767676"
    },
    points: " 285.81,1144.81 285.81,1136.4 1575.74,1136.4 1575.74,1144.81  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#777777"
    },
    points: " 285.81,1139.15 285.81,1130.75 1575.74,1130.75 1575.74,1139.15  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#777777"
    },
    points: " 285.81,1133.5 285.81,1125.25 1575.74,1125.25 1575.74,1133.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#777777"
    },
    points: " 285.81,1128 285.81,1119.6 1575.74,1119.6 1575.74,1128  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#787878"
    },
    points: " 285.81,1122.35 285.81,1113.94 1575.74,1113.94 1575.74,1122.35  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#787878"
    },
    points: " 285.81,1116.85 285.81,1108.45 1575.74,1108.45 1575.74,1116.85  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#797979"
    },
    points: " 285.81,1111.2 285.81,1102.8 1575.74,1102.8 1575.74,1111.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#797979"
    },
    points: " 285.81,1105.7 285.81,1097.3 1575.74,1097.3 1575.74,1105.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#797979"
    },
    points: " 285.81,1100.05 285.81,1091.65 1575.74,1091.65 1575.74,1100.05  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7A7A7A"
    },
    points: " 285.81,1094.39 285.81,1086.16 1575.74,1086.16 1575.74,1094.39  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7A7A7A"
    },
    points: " 285.81,1088.9 285.81,1080.5 1575.74,1080.5 1575.74,1088.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7B7B7B"
    },
    points: " 285.81,1083.25 285.81,1074.85 1575.74,1074.85 1575.74,1083.25  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7B7B7B"
    },
    points: " 285.81,1077.76 285.81,1069.35 1575.74,1069.35 1575.74,1077.76  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7B7B7B"
    },
    points: " 285.81,1072.1 285.81,1063.7 1575.74,1063.7 1575.74,1072.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7C7C7C"
    },
    points: " 285.81,1066.61 285.81,1058.2 1575.74,1058.2 1575.74,1066.61  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7C7C7C"
    },
    points: " 285.81,1060.95 285.81,1052.55 1575.74,1052.55 1575.74,1060.95  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7D7D7D"
    },
    points: " 285.81,1055.3 285.81,1047.05 1575.74,1047.05 1575.74,1055.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7D7D7D"
    },
    points: " 285.81,1049.8 285.81,1041.4 1575.74,1041.4 1575.74,1049.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7D7D7D"
    },
    points: " 285.81,1044.15 285.81,1035.74 1575.74,1035.74 1575.74,1044.15  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7E7E7E"
    },
    points: " 285.81,1038.66 285.81,1030.26 1575.74,1030.26 1575.74,1038.66  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7E7E7E"
    },
    points: " 285.81,1033 285.81,1024.6 1575.74,1024.6 1575.74,1033  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7F7F7F"
    },
    points: " 285.81,1027.51 285.81,1019.11 1575.74,1019.11 1575.74,1027.51  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7F7F7F"
    },
    points: " 285.81,1021.85 285.81,1013.45 1575.74,1013.45 1575.74,1021.85  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7F7F7F"
    },
    points: " 285.81,1016.2 285.81,1007.96 1575.74,1007.96 1575.74,1016.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#808080"
    },
    points: " 285.81,1010.7 285.81,1002.3 1575.74,1002.3 1575.74,1010.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#818181"
    },
    points: " 285.81,1005.05 285.81,996.65 1575.74,996.65 1575.74,1005.05  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#828282"
    },
    points: " 285.81,999.55 285.81,991.16 1575.74,991.16 1575.74,999.55  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#838383"
    },
    points: " 285.81,993.9 285.81,985.5 1575.74,985.5 1575.74,993.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#848484"
    },
    points: " 285.81,988.41 285.81,980.01 1575.74,980.01 1575.74,988.41  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#858585"
    },
    points: " 285.81,982.76 285.81,974.35 1575.74,974.35 1575.74,982.76  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#868686"
    },
    points: " 285.81,977.26 285.81,968.86 1575.74,968.86 1575.74,977.26  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#888888"
    },
    points: " 285.81,971.61 285.81,963.21 1575.74,963.21 1575.74,971.61  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#898989"
    },
    points: " 285.81,965.95 285.81,957.71 1575.74,957.71 1575.74,965.95  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#8A8A8A"
    },
    points: " 285.81,960.46 285.81,952.06 1575.74,952.06 1575.74,960.46  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#8B8B8B"
    },
    points: " 285.81,954.8 285.81,946.4 1575.74,946.4 1575.74,954.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#8C8C8C"
    },
    points: " 285.81,949.31 285.81,940.91 1575.74,940.91 1575.74,949.31  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#8E8E8E"
    },
    points: " 285.81,943.66 285.81,935.26 1575.74,935.26 1575.74,943.66  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#8F8F8F"
    },
    points: " 285.81,938.16 285.81,929.76 1575.74,929.76 1575.74,938.16  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#909090"
    },
    points: " 285.81,932.51 285.81,924.11 1575.74,924.11 1575.74,932.51  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#919191"
    },
    points: " 285.81,926.85 285.81,918.61 1575.74,918.61 1575.74,926.85  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#929292"
    },
    points: " 285.81,921.36 285.81,912.96 1575.74,912.96 1575.74,921.36  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#939393"
    },
    points: " 285.81,915.71 285.81,907.3 1575.74,907.3 1575.74,915.71  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#959595"
    },
    points: " 285.81,910.21 285.81,901.81 1575.74,901.81 1575.74,910.21  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#969696"
    },
    points: " 285.81,904.56 285.81,896.16 1575.74,896.16 1575.74,904.56  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#979797"
    },
    points: " 285.81,899.07 285.81,890.66 1575.74,890.66 1575.74,899.07  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#989898"
    },
    points: " 285.81,893.41 285.81,885.01 1575.74,885.01 1575.74,893.41  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#999999"
    },
    points: " 285.81,887.76 285.81,879.52 1575.74,879.52 1575.74,887.76  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9A9A9A"
    },
    points: " 285.81,882.26 285.81,873.86 1575.74,873.86 1575.74,882.26  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9C9C9C"
    },
    points: " 285.81,876.61 285.81,868.21 1575.74,868.21 1575.74,876.61  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9D9D9D"
    },
    points: " 285.81,871.11 285.81,862.71 1575.74,862.71 1575.74,871.11  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9E9E9E"
    },
    points: " 285.81,865.46 285.81,857.06 1575.74,857.06 1575.74,865.46  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9F9F9F"
    },
    points: " 285.81,859.97 285.81,851.57 1575.74,851.57 1575.74,859.97  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A0A0A0"
    },
    points: " 285.81,854.31 285.81,845.91 1575.74,845.91 1575.74,854.31  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A2A2A2"
    },
    points: " 285.81,848.66 285.81,840.42 1575.74,840.42 1575.74,848.66  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A3A3A3"
    },
    points: " 285.81,843.16 285.81,834.76 1575.74,834.76 1575.74,843.16  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A4A4A4"
    },
    points: " 285.81,837.51 285.81,829.11 1575.74,829.11 1575.74,837.51  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A5A5A5"
    },
    points: " 285.81,832.02 285.81,823.62 1575.74,823.62 1575.74,832.02  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A6A6A6"
    },
    points: " 285.81,826.36 285.81,817.96 1575.74,817.96 1575.74,826.36  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A7A7A7"
    },
    points: " 285.81,820.87 285.81,812.47 1575.74,812.47 1575.74,820.87  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A9A9A9"
    },
    points: " 285.81,815.21 285.81,806.81 1575.74,806.81 1575.74,815.21  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AAAAAA"
    },
    points: " 285.81,809.56 285.81,801.32 1575.74,801.32 1575.74,809.56  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ABABAB"
    },
    points: " 285.81,804.06 285.81,795.67 1575.74,795.67 1575.74,804.06  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ACACAC"
    },
    points: " 285.81,798.41 285.81,790.01 1575.74,790.01 1575.74,798.41  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ADADAD"
    },
    points: " 285.81,792.92 285.81,784.52 1575.74,784.52 1575.74,792.92  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AEAEAE"
    },
    points: " 285.81,787.26 285.81,778.86 1575.74,778.86 1575.74,787.26  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B0B0B0"
    },
    points: " 285.81,781.77 285.81,773.37 1575.74,773.37 1575.74,781.77  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B1B1B1"
    },
    points: " 285.81,776.11 285.81,767.71 1575.74,767.71 1575.74,776.11  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B2B2B2"
    },
    points: " 285.81,770.46 285.81,762.22 1575.74,762.22 1575.74,770.46  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B3B3B3"
    },
    points: " 285.81,764.97 285.81,756.56 1575.74,756.56 1575.74,764.97  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B4B4B4"
    },
    points: " 285.81,759.31 285.81,750.91 1575.74,750.91 1575.74,759.31  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B6B6B6"
    },
    points: " 285.81,753.82 285.81,745.42 1575.74,745.42 1575.74,753.82  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B7B7B7"
    },
    points: " 285.81,748.16 285.81,739.76 1575.74,739.76 1575.74,748.16  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B8B8B8"
    },
    points: " 285.81,742.67 285.81,734.27 1575.74,734.27 1575.74,742.67  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B9B9B9"
    },
    points: " 285.81,737.02 285.81,728.61 1575.74,728.61 1575.74,737.02  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BABABA"
    },
    points: " 285.81,731.36 285.81,723.12 1575.74,723.12 1575.74,731.36  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BBBBBB"
    },
    points: " 285.81,725.87 285.81,717.47 1575.74,717.47 1575.74,725.87  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BDBDBD"
    },
    points: " 285.81,720.21 285.81,711.81 1575.74,711.81 1575.74,720.21  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BEBEBE"
    },
    points: " 285.81,714.72 285.81,706.32 1575.74,706.32 1575.74,714.72  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BFBFBF"
    },
    points: " 285.81,709.07 285.81,700.66 1575.74,700.66 1575.74,709.07  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C0C0C0"
    },
    points: " 285.81,703.57 285.81,695.17 1575.74,695.17 1575.74,703.57  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C1C1C1"
    },
    points: " 285.81,697.92 285.81,689.52 1575.74,689.52 1575.74,697.92  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C2C2C2"
    },
    points: " 285.81,692.26 285.81,684.02 1575.74,684.02 1575.74,692.26  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C4C4C4"
    },
    points: " 285.81,686.77 285.81,678.37 1575.74,678.37 1575.74,686.77  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C5C5C5"
    },
    points: " 285.81,681.12 285.81,672.71 1575.74,672.71 1575.74,681.12  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C6C6C6"
    },
    points: " 285.81,675.62 285.81,667.22 1575.74,667.22 1575.74,675.62  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C7C7C7"
    },
    points: " 285.81,669.97 285.81,661.57 1575.74,661.57 1575.74,669.97  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C8C8C8"
    },
    points: " 285.81,664.47 285.81,656.07 1575.74,656.07 1575.74,664.47  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CACACA"
    },
    points: " 285.81,658.82 285.81,650.42 1575.74,650.42 1575.74,658.82  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CBCBCB"
    },
    points: " 285.81,653.16 285.81,644.93 1575.74,644.93 1575.74,653.16  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CCCCCC"
    },
    points: " 285.81,647.67 285.81,639.27 1575.74,639.27 1575.74,647.67  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CDCDCD"
    },
    points: " 285.81,642.02 285.81,633.62 1575.74,633.62 1575.74,642.02  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CECECE"
    },
    points: " 285.81,636.52 285.81,628.12 1575.74,628.12 1575.74,636.52  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CFCFCF"
    },
    points: " 285.81,630.87 285.81,622.47 1575.74,622.47 1575.74,630.87  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D1D1D1"
    },
    points: " 285.81,625.38 285.81,616.97 1575.74,616.97 1575.74,625.38  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D2D2D2"
    },
    points: " 285.81,619.72 285.81,611.32 1575.74,611.32 1575.74,619.72  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D3D3D3"
    },
    points: " 285.81,614.07 285.81,605.82 1575.74,605.82 1575.74,614.07  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D4D4D4"
    },
    points: " 285.81,608.57 285.81,600.17 1575.74,600.17 1575.74,608.57  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D5D5D5"
    },
    points: " 285.81,602.92 285.81,594.52 1575.74,594.52 1575.74,602.92  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D6D6D6"
    },
    points: " 285.81,597.43 285.81,589.02 1575.74,589.02 1575.74,597.43  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D8D8D8"
    },
    points: " 285.81,591.77 285.81,583.37 1575.74,583.37 1575.74,591.77  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D9D9D9"
    },
    points: " 285.81,586.28 285.81,577.87 1575.74,577.87 1575.74,586.28  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DADADA"
    },
    points: " 285.81,580.62 285.81,572.22 1575.74,572.22 1575.74,580.62  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DBDBDB"
    },
    points: " 285.81,575.13 285.81,566.73 1575.74,566.73 1575.74,575.13  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DCDCDC"
    },
    points: " 285.81,569.47 285.81,561.07 1575.74,561.07 1575.74,569.47  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DEDEDE"
    },
    points: " 285.81,563.82 285.81,555.58 1575.74,555.58 1575.74,563.82  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DFDFDF"
    },
    points: " 285.81,558.33 285.81,549.92 1575.74,549.92 1575.74,558.33  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E0E0E0"
    },
    points: " 285.81,552.67 285.81,544.27 1575.74,544.27 1575.74,552.67  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E1E1E1"
    },
    points: " 285.81,547.18 285.81,538.78 1575.74,538.78 1575.74,547.18  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E2E2E2"
    },
    points: " 285.81,541.52 285.81,533.12 1575.74,533.12 1575.74,541.52  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E3E3E3"
    },
    points: " 285.81,536.03 285.81,527.63 1575.74,527.63 1575.74,536.03  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E5E5E5"
    },
    points: " 285.81,530.38 285.81,521.97 1575.74,521.97 1575.74,530.38  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E6E6E6"
    },
    points: " 285.81,524.72 285.81,516.48 1575.74,516.48 1575.74,524.72  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E7E7E7"
    },
    points: " 285.81,519.23 285.81,510.83 1575.74,510.83 1575.74,519.23  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E8E8E8"
    },
    points: " 285.81,513.57 285.81,505.17 1575.74,505.17 1575.74,513.57  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E9E9E9"
    },
    points: " 285.81,508.08 285.81,499.68 1575.74,499.68 1575.74,508.08  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EAEAEA"
    },
    points: " 285.81,502.42 285.81,494.02 1575.74,494.02 1575.74,502.42  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ECECEC"
    },
    points: " 285.81,496.93 285.81,488.53 1575.74,488.53 1575.74,496.93  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EDEDED"
    },
    points: " 285.81,491.28 285.81,482.88 1575.74,482.88 1575.74,491.28  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EEEEEE"
    },
    points: " 285.81,485.62 285.81,477.38 1575.74,477.38 1575.74,485.62  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EFEFEF"
    },
    points: " 285.81,480.13 285.81,471.73 1575.74,471.73 1575.74,480.13  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EEEEEE"
    },
    points: " 285.81,474.47 285.81,466.07 1575.74,466.07 1575.74,474.47  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EDEDED"
    },
    points: " 285.81,468.98 285.81,460.58 1575.74,460.58 1575.74,468.98  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EBEBEB"
    },
    points: " 285.81,463.33 285.81,454.92 1575.74,454.92 1575.74,463.33  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EAEAEA"
    },
    points: " 285.81,457.84 285.81,449.43 1575.74,449.43 1575.74,457.84  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E9E9E9"
    },
    points: " 285.81,452.18 285.81,443.78 1575.74,443.78 1575.74,452.18  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E8E8E8"
    },
    points: " 285.81,446.52 285.81,438.28 1575.74,438.28 1575.74,446.52  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E7E7E7"
    },
    points: " 285.81,441.03 285.81,432.63 1575.74,432.63 1575.74,441.03  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E6E6E6"
    },
    points: " 285.81,435.38 285.81,426.97 1575.74,426.97 1575.74,435.38  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E5E5E5"
    },
    points: " 285.81,429.88 285.81,421.48 1575.74,421.48 1575.74,429.88  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E3E4E4"
    },
    points: " 285.81,424.23 285.81,415.83 1575.74,415.83 1575.74,424.23  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E2E3E3"
    },
    points: " 285.81,418.73 285.81,410.33 1575.74,410.33 1575.74,418.73  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E1E1E1"
    },
    points: " 285.81,413.08 285.81,404.68 1575.74,404.68 1575.74,413.08  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E0E0E0"
    },
    points: " 285.81,407.43 285.81,399.19 1575.74,399.19 1575.74,407.43  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DFDFDF"
    },
    points: " 285.81,401.93 285.81,393.53 1575.74,393.53 1575.74,401.93  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DEDEDE"
    },
    points: " 285.81,396.28 285.81,387.88 1575.74,387.88 1575.74,396.28  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DCDDDD"
    },
    points: " 285.81,390.78 285.81,382.38 1575.74,382.38 1575.74,390.78  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DBDCDC"
    },
    points: " 285.81,385.13 285.81,376.73 1575.74,376.73 1575.74,385.13  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DADBDB"
    },
    points: " 285.81,379.64 285.81,371.24 1575.74,371.24 1575.74,379.64  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D9DADA"
    },
    points: " 285.81,373.98 285.81,365.58 1575.74,365.58 1575.74,373.98  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D8D9D9"
    },
    points: " 285.81,368.33 285.81,360.09 1575.74,360.09 1575.74,368.33  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D7D7D7"
    },
    points: " 285.81,362.83 285.81,354.43 1575.74,354.43 1575.74,362.83  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D6D6D6"
    },
    points: " 285.81,357.18 285.81,348.78 1575.74,348.78 1575.74,357.18  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D4D5D5"
    },
    points: " 285.81,351.69 285.81,343.29 1575.74,343.29 1575.74,351.69  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D3D4D4"
    },
    points: " 285.81,346.03 285.81,337.63 1575.74,337.63 1575.74,346.03  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D2D3D3"
    },
    points: " 285.81,340.54 285.81,332.14 1575.74,332.14 1575.74,340.54  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D1D2D2"
    },
    points: " 285.81,334.88 285.81,326.48 1575.74,326.48 1575.74,334.88  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D0D1D1"
    },
    points: " 285.81,329.23 285.81,320.99 1575.74,320.99 1575.74,329.23  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CFD0D0"
    },
    points: " 285.81,323.74 285.81,315.33 1575.74,315.33 1575.74,323.74  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CECECE"
    },
    points: " 285.81,318.08 285.81,309.68 1575.74,309.68 1575.74,318.08  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CCCDCD"
    },
    points: " 285.81,312.59 285.81,304.18 1575.74,304.18 1575.74,312.59  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CBCCCC"
    },
    points: " 285.81,306.93 285.81,298.53 1575.74,298.53 1575.74,306.93  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CACBCB"
    },
    points: " 285.81,301.44 285.81,293.04 1575.74,293.04 1575.74,301.44  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000057863401434062919540000017960657755586968231_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C9CACA"
    },
    points: " 285.81,295.79 285.81,284.64 1575.74,284.64 1575.74,295.79  "
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000103952806281833902930000015413116845709605257_",
    d: "M1072.14,1071.45l72.87-71.9l284.35-280.63l73.35-72.38 l73.03-71.9l293.88-290.01h-144.27l-215.69,212.78l-72.22,71.09v0.16l-72.06,71.09l-364.65,359.8V857.22l-140.07-138.3H716.38 l283.23,280.63h1.12v1.14l-0.65-0.65l-364,359.15l-72.22,71.25l-72.06,71.09l-215.69,212.94H420.4l147.67-145.73l73.03-72.06 l73.35-72.38l286.29-282.42L1072.14,1071.45z M1437.44,568.67L1437.44,568.67c1.94,1.78,3.72,3.72,5.65,5.65 C1441.16,572.38,1439.38,570.44,1437.44,568.67L1437.44,568.67z M1446.33,577.71c1.13,1.13,2.26,2.26,3.23,3.55 C1448.43,579.98,1447.46,578.85,1446.33,577.71L1446.33,577.71z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065759388984633307660000003324256418320433598_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103952806281833902930000015413116845709605257_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9B1C12"
    },
    points: " 276.12,1714.48 276.12,1715.77 1869.79,1715.61 1869.79,1714.16  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9B1C12"
    },
    points: " 276.12,1718.68 276.12,1710.12 1869.79,1709.79 1869.79,1718.52  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9B1C12"
    },
    points: " 276.12,1712.86 276.12,1704.3 1869.79,1703.98 1869.79,1712.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9C1C12"
    },
    points: " 276.12,1707.21 276.12,1698.48 1869.79,1698.16 1869.79,1706.89  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9C1B12"
    },
    points: " 276.12,1701.39 276.12,1692.67 1869.79,1692.34 1869.79,1701.07  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9D1B12"
    },
    points: " 276.12,1695.58 276.12,1686.85 1869.79,1686.53 1869.79,1695.25  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9D1B11"
    },
    points: " 276.12,1689.76 276.12,1681.03 1869.79,1680.87 1869.79,1689.44  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9D1B11"
    },
    points: " 276.12,1683.94 276.12,1675.22 1869.79,1675.06 1869.79,1683.62  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9E1B11"
    },
    points: " 276.12,1678.13 276.12,1669.57 1869.79,1669.24 1869.79,1677.97  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9E1B11"
    },
    points: " 276.12,1672.47 276.12,1663.75 1869.79,1663.43 1869.79,1672.15  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9E1B11"
    },
    points: " 276.12,1666.66 276.12,1657.93 1869.79,1657.61 1869.79,1666.33  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9F1B11"
    },
    points: " 276.12,1660.84 276.12,1652.12 1869.79,1651.8 1869.79,1660.52  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9F1B11"
    },
    points: " 276.12,1655.02 276.12,1646.3 1869.79,1645.98 1869.79,1654.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A01B11"
    },
    points: " 276.12,1649.21 276.12,1640.48 1869.79,1640.32 1869.79,1648.88  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A01B11"
    },
    points: " 276.12,1643.39 276.12,1634.83 1869.79,1634.51 1869.79,1643.23  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A01B11"
    },
    points: " 276.12,1637.57 276.12,1629.01 1869.79,1628.69 1869.79,1637.41  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A11B11"
    },
    points: " 276.12,1631.92 276.12,1623.2 1869.79,1622.87 1869.79,1631.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A11B11"
    },
    points: " 276.12,1626.1 276.12,1617.38 1869.79,1617.06 1869.79,1625.78  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A11B11"
    },
    points: " 276.12,1620.29 276.12,1611.56 1869.79,1611.24 1869.79,1619.96  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A21B10"
    },
    points: " 276.12,1614.47 276.12,1605.75 1869.79,1605.58 1869.79,1614.15  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A21B10"
    },
    points: " 276.12,1608.65 276.12,1599.93 1869.79,1599.77 1869.79,1608.33  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A31B10"
    },
    points: " 276.12,1602.83 276.12,1594.28 1869.79,1593.95 1869.79,1602.67  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A31B10"
    },
    points: " 276.12,1597.19 276.12,1588.46 1869.79,1588.14 1869.79,1596.86  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A31B10"
    },
    points: " 276.12,1591.37 276.12,1582.64 1869.79,1582.32 1869.79,1591.05  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A41A10"
    },
    points: " 276.12,1585.55 276.12,1576.82 1869.79,1576.5 1869.79,1585.23  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A41A10"
    },
    points: " 276.12,1579.74 276.12,1571.01 1869.79,1570.69 1869.79,1579.41  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A41A10"
    },
    points: " 276.12,1573.92 276.12,1565.19 1869.79,1565.03 1869.79,1573.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A51A10"
    },
    points: " 276.12,1568.1 276.12,1559.54 1869.79,1559.21 1869.79,1567.94  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A51A10"
    },
    points: " 276.12,1562.45 276.12,1553.72 1869.79,1553.4 1869.79,1562.13  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A51A10"
    },
    points: " 276.12,1556.63 276.12,1547.9 1869.79,1547.58 1869.79,1556.31  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A61A10"
    },
    points: " 276.12,1550.81 276.12,1542.09 1869.79,1541.76 1869.79,1550.49  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A61A10"
    },
    points: " 276.12,1545 276.12,1536.27 1869.79,1535.95 1869.79,1544.68  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A71A0F"
    },
    points: " 276.12,1539.18 276.12,1530.46 1869.79,1530.29 1869.79,1538.86  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A71A0F"
    },
    points: " 276.12,1533.37 276.12,1524.81 1869.79,1524.48 1869.79,1533.04  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A71A0F"
    },
    points: " 276.12,1527.55 276.12,1518.99 1869.79,1518.67 1869.79,1527.39  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A81A0F"
    },
    points: " 276.12,1521.89 276.12,1513.17 1869.79,1512.85 1869.79,1521.57  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A81A0F"
    },
    points: " 276.12,1516.08 276.12,1507.36 1869.79,1507.03 1869.79,1515.76  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A81A0F"
    },
    points: " 276.12,1510.26 276.12,1501.54 1869.79,1501.22 1869.79,1509.94  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A91A0F"
    },
    points: " 276.12,1504.45 276.12,1495.72 1869.79,1495.4 1869.79,1504.12  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A91A0F"
    },
    points: " 276.12,1498.63 276.12,1489.91 1869.79,1489.75 1869.79,1498.31  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AA1A0F"
    },
    points: " 276.12,1492.81 276.12,1484.25 1869.79,1483.93 1869.79,1492.65  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AA1A0F"
    },
    points: " 276.12,1487.16 276.12,1478.43 1869.79,1478.11 1869.79,1486.83  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AA1A0F"
    },
    points: " 276.12,1481.34 276.12,1472.62 1869.79,1472.3 1869.79,1481.02  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AB190F"
    },
    points: " 276.12,1475.52 276.12,1466.8 1869.79,1466.48 1869.79,1475.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AB190F"
    },
    points: " 276.12,1469.71 276.12,1460.99 1869.79,1460.66 1869.79,1469.39  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AB190E"
    },
    points: " 276.12,1463.89 276.12,1455.17 1869.79,1455.01 1869.79,1463.57  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AC190E"
    },
    points: " 276.12,1458.07 275.96,1449.51 1869.79,1449.19 1869.79,1457.75  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AC190E"
    },
    points: " 275.96,1452.26 275.96,1443.7 1869.79,1443.38 1869.79,1452.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AD190E"
    },
    points: " 275.96,1446.61 275.96,1437.88 1869.79,1437.56 1869.79,1446.29  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AD190E"
    },
    points: " 275.96,1440.79 275.96,1432.06 1869.79,1431.74 1869.79,1440.47  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AD190E"
    },
    points: " 275.96,1434.98 275.96,1426.25 1869.79,1425.92 1869.79,1434.65  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AE190E"
    },
    points: " 275.96,1429.16 275.96,1420.43 1869.79,1420.11 1869.79,1428.84  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AE190E"
    },
    points: " 275.96,1423.34 275.96,1414.61 1869.79,1414.45 1869.79,1423.02  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AE190E"
    },
    points: " 275.96,1417.52 275.96,1408.96 1869.79,1408.64 1869.79,1417.36  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AF190E"
    },
    points: " 275.96,1411.87 275.96,1403.14 1869.79,1402.82 1869.79,1411.55  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AF190E"
    },
    points: " 275.96,1406.05 275.96,1397.33 1869.79,1397 1869.79,1405.73  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B0190E"
    },
    points: " 275.96,1400.24 275.96,1391.51 1869.79,1391.19 1869.79,1399.91  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B0190D"
    },
    points: " 275.96,1394.42 275.96,1385.69 1869.79,1385.37 1869.79,1394.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B0190D"
    },
    points: " 275.96,1388.6 275.96,1379.88 1869.79,1379.72 1869.79,1388.28  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B1190D"
    },
    points: " 275.96,1382.79 275.96,1374.23 1869.79,1373.9 1869.79,1382.63  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B1190D"
    },
    points: " 275.96,1376.97 275.96,1368.41 1869.79,1368.09 1869.79,1376.81  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B1190D"
    },
    points: " 275.96,1371.32 275.96,1362.59 1869.79,1362.27 1869.79,1370.99  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B2190D"
    },
    points: " 275.96,1365.5 275.96,1356.78 1869.79,1356.45 1869.79,1365.18  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B2180D"
    },
    points: " 275.96,1359.68 275.96,1350.96 1869.79,1350.64 1869.79,1359.36  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B3180D"
    },
    points: " 275.96,1353.87 275.96,1345.14 1869.79,1344.98 1869.79,1353.54  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B3180D"
    },
    points: " 275.96,1348.05 275.96,1339.33 1869.79,1339.17 1869.79,1347.73  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B3180D"
    },
    points: " 275.96,1342.23 275.96,1333.67 1869.79,1333.35 1869.79,1342.07  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B4180D"
    },
    points: " 275.96,1336.58 275.96,1327.86 1869.79,1327.53 1869.79,1336.26  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B4180D"
    },
    points: " 275.96,1330.76 275.96,1322.04 1869.79,1321.72 1869.79,1330.44  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B4180D"
    },
    points: " 275.96,1324.95 275.96,1316.22 1869.79,1315.9 1869.79,1324.62  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B5180C"
    },
    points: " 275.96,1319.13 275.96,1310.41 1869.79,1310.08 1869.79,1318.81  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B5180C"
    },
    points: " 275.96,1313.31 275.96,1304.59 1869.79,1304.43 1869.79,1312.99  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B6180C"
    },
    points: " 275.96,1307.5 275.96,1298.94 1869.79,1298.61 1869.79,1307.34  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B6180C"
    },
    points: " 275.96,1301.69 275.96,1293.12 1869.79,1292.8 1869.79,1301.52  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B6180C"
    },
    points: " 275.96,1296.03 275.96,1287.3 1869.79,1286.98 1869.79,1295.71  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B7180C"
    },
    points: " 275.96,1290.21 275.96,1281.49 1869.79,1281.16 1869.79,1289.89  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B7180C"
    },
    points: " 275.96,1284.4 275.96,1275.67 1869.79,1275.35 1869.79,1284.08  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B7180C"
    },
    points: " 275.96,1278.58 275.96,1269.85 1869.79,1269.69 1869.79,1278.26  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B8180C"
    },
    points: " 275.96,1272.76 275.96,1264.2 1869.79,1263.87 1869.79,1272.44  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B8180C"
    },
    points: " 275.96,1266.95 275.96,1258.38 1869.79,1258.06 1869.79,1266.79  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B8180C"
    },
    points: " 275.96,1261.29 275.96,1252.57 1869.79,1252.24 1869.79,1260.97  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B9180C"
    },
    points: " 275.96,1255.48 275.96,1246.75 1869.79,1246.43 1869.79,1255.15  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B9170C"
    },
    points: " 275.96,1249.66 275.96,1240.94 1869.79,1240.61 1869.79,1249.34  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BA170B"
    },
    points: " 275.96,1243.84 275.96,1235.12 1869.79,1234.8 1869.79,1243.52  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BA170B"
    },
    points: " 275.96,1238.03 275.96,1229.3 1869.79,1229.14 1869.79,1237.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BA170B"
    },
    points: " 275.96,1232.21 275.96,1223.65 1869.79,1223.33 1869.79,1232.05  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BB170B"
    },
    points: " 275.96,1226.55 275.96,1217.83 1869.79,1217.51 1869.79,1226.23  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BB170B"
    },
    points: " 275.96,1220.74 275.96,1212.02 1869.79,1211.69 1869.79,1220.42  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BB170B"
    },
    points: " 275.96,1214.92 275.96,1206.2 1869.79,1205.88 1869.79,1214.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BC170B"
    },
    points: " 275.96,1209.1 275.96,1200.38 1869.79,1200.06 1869.79,1208.78  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BC170B"
    },
    points: " 275.96,1203.29 275.96,1194.57 1869.79,1194.41 1869.79,1202.97  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BD170B"
    },
    points: " 275.96,1197.47 275.96,1188.91 1869.79,1188.59 1869.79,1197.15  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BD170B"
    },
    points: " 275.96,1191.66 275.96,1183.09 1869.79,1182.77 1869.79,1191.49  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BD170B"
    },
    points: " 275.96,1186 275.96,1177.28 1869.79,1176.96 1869.79,1185.68  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BE170B"
    },
    points: " 275.96,1180.18 275.96,1171.46 1869.79,1171.14 1869.79,1179.86  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BE170B"
    },
    points: " 275.96,1174.37 275.96,1165.65 1869.79,1165.32 1869.79,1174.04  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BE170A"
    },
    points: " 275.96,1168.56 275.96,1159.83 1869.79,1159.51 1869.79,1168.23  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BF170A"
    },
    points: " 275.96,1162.74 275.96,1154.01 1869.79,1153.85 1869.79,1162.42  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BF170A"
    },
    points: " 275.96,1156.92 275.96,1148.36 1869.79,1148.04 1869.79,1156.76  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C0170A"
    },
    points: " 275.96,1151.27 275.96,1142.54 1869.79,1142.22 1869.79,1150.95  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C0170A"
    },
    points: " 275.96,1145.45 275.96,1136.72 1869.79,1136.4 1869.79,1145.13  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C0170A"
    },
    points: " 275.96,1139.64 275.96,1130.91 1869.79,1130.59 1869.79,1139.31  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C1160A"
    },
    points: " 275.96,1133.82 275.96,1125.09 1869.79,1124.77 1869.79,1133.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C1160A"
    },
    points: " 275.96,1128 275.96,1119.28 1869.79,1119.11 1869.79,1127.68  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C1160A"
    },
    points: " 275.96,1122.19 275.96,1113.62 1869.79,1113.3 1869.79,1121.86  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C2160A"
    },
    points: " 275.96,1116.37 275.96,1107.8 1869.79,1107.48 1869.79,1116.21  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C2160A"
    },
    points: " 275.96,1110.71 275.96,1101.99 1869.79,1101.66 1869.79,1110.39  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C3160A"
    },
    points: " 275.96,1104.9 275.96,1096.18 1869.79,1095.85 1869.79,1104.57  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C31609"
    },
    points: " 275.96,1099.08 275.96,1090.36 1869.79,1090.04 1869.79,1098.76  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C31609"
    },
    points: " 275.96,1093.27 275.96,1084.54 1869.79,1084.38 1869.79,1092.94  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C41609"
    },
    points: " 275.96,1087.45 275.96,1078.73 1869.79,1078.56 1869.79,1087.13  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C41609"
    },
    points: " 275.96,1081.63 275.96,1073.07 1869.79,1072.75 1869.79,1081.47  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C41609"
    },
    points: " 275.96,1075.98 275.96,1067.26 1869.79,1066.93 1869.79,1075.65  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C51609"
    },
    points: " 275.96,1070.16 275.96,1061.44 1869.79,1061.12 1869.79,1069.84  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C51609"
    },
    points: " 275.96,1064.34 275.96,1055.62 1869.79,1055.3 1869.79,1064.02  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C61609"
    },
    points: " 275.96,1058.53 275.96,1049.8 1869.79,1049.48 1869.79,1058.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C61609"
    },
    points: " 275.96,1052.71 275.96,1043.99 1869.79,1043.83 1869.79,1052.39  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C61609"
    },
    points: " 275.96,1046.89 275.96,1038.33 1869.79,1038.01 1869.79,1046.73  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C71609"
    },
    points: " 275.96,1041.08 275.96,1032.52 1869.79,1032.19 1869.79,1040.92  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C71609"
    },
    points: " 275.96,1035.42 275.96,1026.7 1869.79,1026.38 1869.79,1035.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C71609"
    },
    points: " 275.96,1029.61 275.96,1020.88 1869.79,1020.56 1869.79,1029.28  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C81608"
    },
    points: " 275.96,1023.79 275.96,1015.07 1869.79,1014.74 1869.79,1023.47  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C81508"
    },
    points: " 275.96,1017.98 275.96,1009.25 1869.79,1009.09 1869.79,1017.66  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C91508"
    },
    points: " 275.96,1012.16 275.96,1003.43 1869.79,1003.27 1869.79,1011.84  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C91508"
    },
    points: " 275.96,1006.35 275.96,997.78 1869.79,997.46 1869.79,1006.18  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C91508"
    },
    points: " 275.96,1000.69 275.96,991.96 1869.79,991.64 1869.79,1000.37  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CA1508"
    },
    points: " 275.96,994.87 275.96,986.15 1869.79,985.82 1869.79,994.55  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CA1508"
    },
    points: " 275.96,989.06 275.96,980.33 1869.79,980.01 1869.79,988.73  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CA1508"
    },
    points: " 275.96,983.24 275.96,974.52 1869.79,974.19 1869.79,982.92  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CB1508"
    },
    points: " 275.96,977.42 275.96,968.7 1869.79,968.54 1869.79,977.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CB1508"
    },
    points: " 275.96,971.61 275.96,963.04 1869.79,962.72 1869.79,971.45  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CB1508"
    },
    points: " 275.96,965.95 275.96,957.23 1869.62,956.91 1869.79,965.63  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CC1508"
    },
    points: " 275.96,960.14 275.96,951.41 1869.62,951.09 1869.79,959.81  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CC1508"
    },
    points: " 275.96,954.32 275.96,945.6 1869.62,945.27 1869.62,954  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CD1507"
    },
    points: " 275.96,948.5 275.96,939.78 1869.62,939.46 1869.62,948.18  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CD1507"
    },
    points: " 275.96,942.69 275.96,933.96 1869.62,933.8 1869.62,942.36  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CD1507"
    },
    points: " 275.96,936.87 275.96,928.31 1869.62,927.98 1869.62,936.55  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CE1507"
    },
    points: " 275.96,931.05 275.96,922.49 1869.62,922.17 1869.62,930.89  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CE1507"
    },
    points: " 275.96,925.4 275.96,916.68 1869.62,916.35 1869.62,925.08  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CE1507"
    },
    points: " 275.96,919.58 275.96,910.86 1869.62,910.54 1869.62,919.26  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CF1507"
    },
    points: " 275.96,913.77 275.96,905.04 1869.62,904.72 1869.62,913.44  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CF1407"
    },
    points: " 275.96,907.95 275.96,899.23 1869.62,898.9 1869.62,907.63  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D01407"
    },
    points: " 275.96,902.14 275.96,893.41 1869.62,893.25 1869.62,901.81  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D01407"
    },
    points: " 275.96,896.32 275.96,887.76 1869.62,887.43 1869.62,896.16  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D01407"
    },
    points: " 275.96,890.66 275.96,881.94 1869.62,881.62 1869.62,890.34  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D11407"
    },
    points: " 275.96,884.85 275.96,876.12 1869.62,875.8 1869.62,884.52  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D11407"
    },
    points: " 275.96,879.03 275.96,870.31 1869.62,869.98 1869.62,878.71  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D11406"
    },
    points: " 275.96,873.21 275.96,864.49 1869.62,864.17 1869.62,872.89  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D21406"
    },
    points: " 275.96,867.4 275.96,858.67 1869.62,858.51 1869.62,867.08  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D21406"
    },
    points: " 275.96,861.58 275.96,853.02 1869.62,852.7 1869.62,861.26  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D31406"
    },
    points: " 275.96,855.77 275.96,847.2 1869.62,846.88 1869.62,855.61  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D31406"
    },
    points: " 275.96,850.11 275.96,841.39 1869.62,841.06 1869.62,849.79  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D31406"
    },
    points: " 275.96,844.3 275.96,835.57 1869.62,835.25 1869.62,843.97  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D41406"
    },
    points: " 275.96,838.48 275.96,829.75 1869.62,829.43 1869.62,838.16  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D41406"
    },
    points: " 275.96,832.66 275.96,823.94 1869.62,823.62 1869.62,832.34  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D41406"
    },
    points: " 275.96,826.85 275.96,818.12 1869.62,817.96 1869.62,826.52  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D51406"
    },
    points: " 275.96,821.03 275.96,812.47 1869.62,812.14 1869.62,820.87  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D51406"
    },
    points: " 275.96,815.38 275.96,806.65 1869.62,806.33 1869.62,815.05  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D61406"
    },
    points: " 275.96,809.56 275.96,800.83 1869.62,800.51 1869.62,809.24  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D61405"
    },
    points: " 275.96,803.74 275.96,795.02 1869.62,794.69 1869.62,803.42  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D61405"
    },
    points: " 275.96,797.93 275.96,789.2 1869.62,788.88 1869.62,797.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D71305"
    },
    points: " 275.96,792.11 275.96,783.39 1869.62,783.23 1869.62,791.79  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D71305"
    },
    points: " 275.96,786.29 275.96,777.73 1869.62,777.41 1869.62,786.13  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D71305"
    },
    points: " 275.96,780.48 275.96,771.92 1869.62,771.59 1869.62,780.31  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D81305"
    },
    points: " 275.96,774.82 275.96,766.1 1869.62,765.78 1869.62,774.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D81305"
    },
    points: " 275.96,769 275.96,760.28 1869.62,759.96 1869.62,768.68  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D91305"
    },
    points: " 275.96,763.19 275.96,754.47 1869.62,754.14 1869.62,762.86  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D91305"
    },
    points: " 275.96,757.37 275.96,748.65 1869.62,748.49 1869.62,757.05  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D91305"
    },
    points: " 275.96,751.56 275.96,742.83 1869.62,742.67 1869.62,751.23  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DA1305"
    },
    points: " 275.96,745.74 275.96,737.18 1869.62,736.85 1869.62,745.58  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DA1305"
    },
    points: " 275.96,740.09 275.96,731.36 1869.62,731.04 1869.62,739.76  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DA1305"
    },
    points: " 275.96,734.27 275.96,725.54 1869.62,725.22 1869.62,733.95  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DB1304"
    },
    points: " 275.96,728.45 275.96,719.73 1869.62,719.41 1869.62,728.13  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DB1304"
    },
    points: " 275.96,722.64 275.96,713.91 1869.62,713.59 1869.62,722.31  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DC1304"
    },
    points: " 275.96,716.82 275.96,708.1 1869.62,707.93 1869.62,716.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DC1304"
    },
    points: " 275.96,711.01 275.96,702.44 1869.62,702.12 1869.62,710.84  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DC1304"
    },
    points: " 275.96,705.19 275.96,696.62 1869.62,696.3 1869.62,705.03  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DD1304"
    },
    points: " 275.96,699.53 275.96,690.81 1869.62,690.48 1869.62,699.21  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DD1304"
    },
    points: " 275.96,693.72 275.96,684.99 1869.62,684.67 1869.62,693.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DD1304"
    },
    points: " 275.96,687.9 275.96,679.18 1869.62,678.85 1869.62,687.58  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DE1204"
    },
    points: " 275.96,682.08 275.96,673.36 1869.62,673.2 1869.62,681.76  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DE1204"
    },
    points: " 275.96,676.27 275.96,667.71 1869.62,667.38 1869.62,675.95  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DE1204"
    },
    points: " 275.96,670.45 275.96,661.89 1869.62,661.57 1869.62,670.29  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DF1204"
    },
    points: " 275.96,664.8 275.96,656.07 1869.62,655.75 1869.62,664.47  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DF1204"
    },
    points: " 275.96,658.98 275.96,650.26 1869.62,649.93 1869.62,658.66  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E01203"
    },
    points: " 275.96,653.16 275.96,644.44 1869.62,644.12 1869.62,652.84  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E01203"
    },
    points: " 275.96,647.35 275.96,638.62 1869.62,638.3 1869.62,647.02  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E01203"
    },
    points: " 275.96,641.53 275.96,632.81 1869.62,632.65 1869.62,641.21  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E11203"
    },
    points: " 275.96,635.71 275.96,627.15 1869.62,626.83 1869.62,635.55  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E11203"
    },
    points: " 275.96,630.06 275.96,621.34 1869.62,621.01 1869.62,629.74  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E11203"
    },
    points: " 275.96,624.24 275.96,615.52 1869.62,615.2 1869.62,623.92  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E21203"
    },
    points: " 275.96,618.43 275.96,609.7 1869.62,609.38 1869.62,618.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E21203"
    },
    points: " 275.96,612.61 275.96,603.89 1869.62,603.57 1869.62,612.29  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E31203"
    },
    points: " 275.96,606.8 275.96,598.07 1869.62,597.91 1869.62,606.47  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E31203"
    },
    points: " 275.96,600.98 275.96,592.42 1869.62,592.09 1869.62,600.66  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E31203"
    },
    points: " 275.96,595.16 275.96,586.6 1869.62,586.28 1869.62,595  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E41203"
    },
    points: " 275.96,589.51 275.96,580.78 1869.62,580.46 1869.62,589.18  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E41203"
    },
    points: " 275.96,583.69 275.8,574.97 1869.62,574.64 1869.62,583.37  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E41202"
    },
    points: " 275.96,577.87 275.8,569.15 1869.62,568.83 1869.62,577.55  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E51202"
    },
    points: " 275.8,572.06 275.8,563.33 1869.62,563.01 1869.62,571.74  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E51102"
    },
    points: " 275.8,566.24 275.8,557.52 1869.62,557.36 1869.62,565.92  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E61102"
    },
    points: " 275.8,560.43 275.8,551.86 1869.62,551.54 1869.62,560.27  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E61102"
    },
    points: " 275.8,554.77 275.8,546.05 1869.62,545.72 1869.62,554.45  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E61102"
    },
    points: " 275.8,548.96 275.8,540.23 1869.62,539.91 1869.62,548.63  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E71102"
    },
    points: " 275.8,543.14 275.8,534.41 1869.62,534.09 1869.62,542.82  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E71102"
    },
    points: " 275.8,537.32 275.8,528.6 1869.62,528.28 1869.62,537  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E71102"
    },
    points: " 275.8,531.51 275.8,522.78 1869.62,522.62 1869.62,531.18  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E81102"
    },
    points: " 275.8,525.69 275.8,517.13 1869.62,516.8 1869.62,525.37  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E81102"
    },
    points: " 275.8,519.87 275.8,511.31 1869.62,510.99 1869.62,519.71  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E91102"
    },
    points: " 275.8,514.22 275.8,505.49 1869.62,505.17 1869.62,513.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E91101"
    },
    points: " 275.8,508.4 275.8,499.68 1869.62,499.35 1869.62,508.08  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E91101"
    },
    points: " 275.8,502.59 275.8,493.86 1869.62,493.54 1869.62,502.26  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EA1101"
    },
    points: " 275.8,496.77 275.8,488.05 1869.62,487.89 1869.62,496.45  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EA1101"
    },
    points: " 275.8,490.95 275.8,482.23 1869.62,482.07 1869.62,490.63  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EA1101"
    },
    points: " 275.8,485.14 275.8,476.58 1869.62,476.25 1869.62,484.97  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EB1101"
    },
    points: " 275.8,479.48 275.8,470.76 1869.62,470.44 1869.62,479.16  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EB1101"
    },
    points: " 275.8,473.67 275.8,464.94 1869.62,464.62 1869.62,473.34  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EC1101"
    },
    points: " 275.8,467.85 275.8,459.13 1869.62,458.8 1869.62,467.53  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EC1101"
    },
    points: " 275.8,462.03 275.8,453.31 1869.62,452.99 1869.62,461.71  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EC1101"
    },
    points: " 275.8,456.22 275.8,447.49 1869.62,447.33 1869.62,455.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ED1001"
    },
    points: " 275.8,450.4 275.8,441.84 1869.62,441.52 1869.62,450.24  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ED1001"
    },
    points: " 275.8,444.58 275.8,436.02 1869.62,435.7 1869.62,444.42  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ED1001"
    },
    points: " 275.8,438.93 275.8,430.21 1869.62,429.88 1869.62,438.61  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EE1000"
    },
    points: " 275.8,433.12 275.8,424.39 1869.62,424.07 1869.62,432.79  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EE1000"
    },
    points: " 275.8,427.3 275.8,418.57 1869.62,418.25 1869.62,426.97  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EF1000"
    },
    points: " 275.8,421.48 275.8,412.76 1869.62,412.59 1869.62,421.16  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EF1000"
    },
    points: " 275.8,415.67 275.8,406.94 1869.62,406.78 1869.62,415.34  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EF1000"
    },
    points: " 275.8,409.85 275.8,401.29 1869.62,400.96 1869.62,409.69  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F01000"
    },
    points: " 275.8,404.19 275.8,395.47 1869.62,395.15 1869.62,403.87  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000065759388984633307660000003324256418320433598_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F01000"
    },
    points: " 275.8,398.38 275.8,284.96 1869.62,284.64 1869.62,398.06  "
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000098904341737255004640000011976116523672894869_",
    d: "M1436.15,1431.9c44.59,0,89.67-4.85,139.59-7.43 l-73.03-72.06l-73.35-72.38l-242.67-239.44l-41.68-41.04l-72.87,71.9l50.09,49.44l241.86,239.6L1436.15,1431.9 c-47.99,0-95.65-4.85-149.12-7.59c-81.76,55.26-180.31,87.4-286.3,87.4c-63.01,0-123.43-11.3-179.17-32.15 c-38.13-14.22-74-32.8-107.12-55.26l-73.35,72.38c29.73,21.48,61.39,40.55,94.84,56.54c80.14,38.29,169.97,59.78,264.8,59.78 C1170.86,1613.02,1324.99,1543.87,1436.15,1431.9L1436.15,1431.9z M1360.37,502.42c-12.6-9.21-25.52-17.93-38.93-26.01 c-93.23-57.36-203.09-90.48-320.71-90.48c-338.96,0-613.62,274.66-613.62,613.62c0,102.6,25.2,199.38,69.8,284.52 c12.44,23.75,26.5,46.53,41.85,68.34l73.35-72.38c-13.57-20.68-25.69-42.49-36.19-65.11c-30.54-65.43-47.5-138.46-47.5-215.37 c0-103.56,30.86-200.01,83.69-280.63c91.44-139.43,249.29-231.68,428.63-231.68c89.67,0,174.01,23.1,247.36,63.66 c13.41,7.43,26.34,15.35,38.94,23.75L1360.37,502.42z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127744662488414375050000005796373460177791415_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098904341737255004640000011976116523672894869_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C9CACA"
    },
    points: " 387.11,1613.02 387.11,1610.76 1575.74,1610.76 1575.74,1613.02  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CACBCB"
    },
    points: " 387.11,1613.02 387.11,1605.91 1575.74,1605.91 1575.74,1613.02  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CBCCCC"
    },
    points: " 387.11,1608.33 387.11,1601.06 1575.74,1601.06 1575.74,1608.33  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CCCDCD"
    },
    points: " 387.11,1603.49 387.11,1596.37 1575.74,1596.37 1575.74,1603.49  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CECECE"
    },
    points: " 387.11,1598.64 387.11,1591.53 1575.74,1591.53 1575.74,1598.64  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CFD0D0"
    },
    points: " 387.11,1593.95 387.11,1586.68 1575.74,1586.68 1575.74,1593.95  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D0D1D1"
    },
    points: " 387.11,1589.1 387.11,1582 1575.74,1582 1575.74,1589.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D1D2D2"
    },
    points: " 387.11,1584.26 387.11,1577.15 1575.74,1577.15 1575.74,1584.26  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D2D3D3"
    },
    points: " 387.11,1579.57 387.11,1572.3 1575.74,1572.3 1575.74,1579.57  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D3D4D4"
    },
    points: " 387.11,1574.73 387.11,1567.62 1575.74,1567.62 1575.74,1574.73  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D4D5D5"
    },
    points: " 387.11,1569.88 387.11,1562.77 1575.74,1562.77 1575.74,1569.88  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D6D6D6"
    },
    points: " 387.11,1565.19 387.11,1557.92 1575.74,1557.92 1575.74,1565.19  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D7D7D7"
    },
    points: " 387.11,1560.34 387.11,1553.24 1575.74,1553.24 1575.74,1560.34  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D8D9D9"
    },
    points: " 387.11,1555.5 387.11,1548.39 1575.74,1548.39 1575.74,1555.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D9DADA"
    },
    points: " 387.11,1550.81 387.11,1543.55 1575.74,1543.55 1575.74,1550.81  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DADBDB"
    },
    points: " 387.11,1545.97 387.11,1538.86 1575.74,1538.86 1575.74,1545.97  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DBDCDC"
    },
    points: " 387.11,1541.12 387.11,1534.01 1575.74,1534.01 1575.74,1541.12  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DCDDDD"
    },
    points: " 387.11,1536.43 387.11,1529.16 1575.74,1529.16 1575.74,1536.43  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DEDEDE"
    },
    points: " 387.11,1531.59 387.11,1524.48 1575.74,1524.48 1575.74,1531.59  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DFDFDF"
    },
    points: " 387.11,1526.74 387.11,1519.64 1575.74,1519.64 1575.74,1526.74  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E0E0E0"
    },
    points: " 387.11,1522.06 387.11,1514.79 1575.74,1514.79 1575.74,1522.06  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E1E1E1"
    },
    points: " 387.11,1517.21 387.11,1510.1 1575.74,1510.1 1575.74,1517.21  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E2E3E3"
    },
    points: " 387.11,1512.37 387.11,1505.25 1575.74,1505.25 1575.74,1512.37  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E3E4E4"
    },
    points: " 387.11,1507.68 387.11,1500.41 1575.74,1500.41 1575.74,1507.68  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E5E5E5"
    },
    points: " 387.11,1502.83 387.11,1495.72 1575.74,1495.72 1575.74,1502.83  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E6E6E6"
    },
    points: " 387.11,1497.98 387.11,1490.88 1575.74,1490.88 1575.74,1497.98  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E7E7E7"
    },
    points: " 387.11,1493.3 387.11,1486.03 1575.74,1486.03 1575.74,1493.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E8E8E8"
    },
    points: " 387.11,1488.45 387.11,1481.34 1575.74,1481.34 1575.74,1488.45  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E9E9E9"
    },
    points: " 387.11,1483.61 387.11,1476.5 1575.74,1476.5 1575.74,1483.61  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EAEAEA"
    },
    points: " 387.11,1478.92 387.11,1471.65 1575.74,1471.65 1575.74,1478.92  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EBEBEB"
    },
    points: " 387.11,1474.07 387.11,1466.96 1575.74,1466.96 1575.74,1474.07  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EDEDED"
    },
    points: " 387.11,1469.22 387.11,1462.11 1575.74,1462.11 1575.74,1469.22  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EEEEEE"
    },
    points: " 387.11,1464.54 387.11,1457.27 1575.74,1457.27 1575.74,1464.54  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EFEFEF"
    },
    points: " 387.11,1459.69 387.11,1452.59 1575.74,1452.59 1575.74,1459.69  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EEEEEE"
    },
    points: " 387.11,1454.84 387.11,1447.74 1575.74,1447.74 1575.74,1454.84  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EDEDED"
    },
    points: " 387.11,1450.16 387.11,1442.89 1575.74,1442.89 1575.74,1450.16  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ECECEC"
    },
    points: " 387.11,1445.31 387.11,1438.2 1575.74,1438.2 1575.74,1445.31  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#EAEAEA"
    },
    points: " 387.11,1440.47 387.11,1433.35 1575.74,1433.35 1575.74,1440.47  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E9E9E9"
    },
    points: " 387.11,1435.78 387.11,1428.51 1575.74,1428.51 1575.74,1435.78  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E8E8E8"
    },
    points: " 387.11,1430.93 387.11,1423.83 1575.74,1423.83 1575.74,1430.93  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E7E7E7"
    },
    points: " 387.11,1426.09 387.11,1418.98 1575.74,1418.98 1575.74,1426.09  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E6E6E6"
    },
    points: " 387.11,1421.4 387.11,1414.13 1575.74,1414.13 1575.74,1421.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E5E5E5"
    },
    points: " 387.11,1416.56 387.11,1409.44 1575.74,1409.44 1575.74,1416.56  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E3E3E3"
    },
    points: " 387.11,1411.71 387.11,1404.6 1575.74,1404.6 1575.74,1411.71  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E2E2E2"
    },
    points: " 387.11,1407.02 387.11,1399.75 1575.74,1399.75 1575.74,1407.02  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E1E1E1"
    },
    points: " 387.11,1402.17 387.11,1395.07 1575.74,1395.07 1575.74,1402.17  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E0E0E0"
    },
    points: " 387.11,1397.33 387.11,1390.22 1575.74,1390.22 1575.74,1397.33  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DFDFDF"
    },
    points: " 387.11,1392.65 387.11,1385.37 1575.74,1385.37 1575.74,1392.65  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DEDEDE"
    },
    points: " 387.11,1387.8 387.11,1380.69 1575.74,1380.69 1575.74,1387.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DCDCDC"
    },
    points: " 387.11,1382.95 387.11,1375.84 1575.74,1375.84 1575.74,1382.95  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DBDBDB"
    },
    points: " 387.11,1378.26 387.11,1370.99 1575.74,1370.99 1575.74,1378.26  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#DADADA"
    },
    points: " 387.11,1373.42 387.11,1366.15 1575.74,1366.15 1575.74,1373.42  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D9D9D9"
    },
    points: " 387.11,1368.57 387.11,1361.46 1575.74,1361.46 1575.74,1368.57  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D8D8D8"
    },
    points: " 387.11,1363.89 387.11,1356.62 1575.74,1356.62 1575.74,1363.89  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D6D6D6"
    },
    points: " 387.11,1359.04 387.11,1351.77 1575.74,1351.77 1575.74,1359.04  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D5D5D5"
    },
    points: " 387.11,1354.19 387.11,1347.08 1575.74,1347.08 1575.74,1354.19  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D4D4D4"
    },
    points: " 387.11,1349.5 387.11,1342.23 1575.74,1342.23 1575.74,1349.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D3D3D3"
    },
    points: " 387.11,1344.66 387.11,1337.39 1575.74,1337.39 1575.74,1344.66  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D2D2D2"
    },
    points: " 387.11,1339.81 387.11,1332.7 1575.74,1332.7 1575.74,1339.81  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#D1D1D1"
    },
    points: " 387.11,1335.13 387.11,1327.86 1575.74,1327.86 1575.74,1335.13  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CFCFCF"
    },
    points: " 387.11,1330.28 387.11,1323.01 1575.74,1323.01 1575.74,1330.28  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CECECE"
    },
    points: " 387.11,1325.43 387.11,1318.32 1575.74,1318.32 1575.74,1325.43  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CDCDCD"
    },
    points: " 387.11,1320.75 387.11,1313.48 1575.74,1313.48 1575.74,1320.75  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CCCCCC"
    },
    points: " 387.11,1315.9 387.11,1308.63 1575.74,1308.63 1575.74,1315.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CBCBCB"
    },
    points: " 387.11,1311.05 387.11,1303.94 1575.74,1303.94 1575.74,1311.05  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CACACA"
    },
    points: " 387.11,1306.37 387.11,1299.1 1575.74,1299.1 1575.74,1306.37  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C8C8C8"
    },
    points: " 387.11,1301.52 387.11,1294.25 1575.74,1294.25 1575.74,1301.52  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C7C7C7"
    },
    points: " 387.11,1296.68 387.11,1289.57 1575.74,1289.57 1575.74,1296.68  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C6C6C6"
    },
    points: " 387.11,1291.99 387.11,1284.72 1575.74,1284.72 1575.74,1291.99  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C5C5C5"
    },
    points: " 387.11,1287.14 387.11,1279.87 1575.74,1279.87 1575.74,1287.14  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C4C4C4"
    },
    points: " 387.11,1282.29 387.11,1275.18 1575.74,1275.18 1575.74,1282.29  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C2C2C2"
    },
    points: " 387.11,1277.61 387.11,1270.34 1575.74,1270.34 1575.74,1277.61  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C1C1C1"
    },
    points: " 387.11,1272.76 387.11,1265.5 1575.74,1265.5 1575.74,1272.76  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#C0C0C0"
    },
    points: " 387.11,1267.92 387.11,1260.81 1575.74,1260.81 1575.74,1267.92  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BFBFBF"
    },
    points: " 387.11,1263.23 387.11,1255.96 1575.74,1255.96 1575.74,1263.23  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BEBEBE"
    },
    points: " 387.11,1258.38 387.11,1251.11 1575.74,1251.11 1575.74,1258.38  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BDBDBD"
    },
    points: " 387.11,1253.54 387.11,1246.43 1575.74,1246.43 1575.74,1253.54  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BBBBBB"
    },
    points: " 387.11,1248.85 387.11,1241.58 1575.74,1241.58 1575.74,1248.85  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#BABABA"
    },
    points: " 387.11,1244 387.11,1236.74 1575.74,1236.74 1575.74,1244  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B9B9B9"
    },
    points: " 387.11,1239.16 387.11,1232.05 1575.74,1232.05 1575.74,1239.16  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B8B8B8"
    },
    points: " 387.11,1234.47 387.11,1227.2 1575.74,1227.2 1575.74,1234.47  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B7B7B7"
    },
    points: " 387.11,1229.63 387.11,1222.35 1575.74,1222.35 1575.74,1229.63  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B6B6B6"
    },
    points: " 387.11,1224.78 387.11,1217.67 1575.74,1217.67 1575.74,1224.78  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B4B4B4"
    },
    points: " 387.11,1220.09 387.11,1212.82 1575.74,1212.82 1575.74,1220.09  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B3B3B3"
    },
    points: " 387.11,1215.25 387.11,1207.97 1575.74,1207.97 1575.74,1215.25  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B2B2B2"
    },
    points: " 387.11,1210.4 387.11,1203.29 1575.74,1203.29 1575.74,1210.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B1B1B1"
    },
    points: " 387.11,1205.72 387.11,1198.44 1575.74,1198.44 1575.74,1205.72  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#B0B0B0"
    },
    points: " 387.11,1200.87 387.11,1193.6 1575.74,1193.6 1575.74,1200.87  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AEAEAE"
    },
    points: " 387.11,1196.02 387.11,1188.91 1575.74,1188.91 1575.74,1196.02  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ADADAD"
    },
    points: " 387.11,1191.33 387.11,1184.06 1575.74,1184.06 1575.74,1191.33  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ACACAC"
    },
    points: " 387.11,1186.48 387.11,1179.21 1575.74,1179.21 1575.74,1186.48  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ABABAB"
    },
    points: " 387.11,1181.64 387.11,1174.53 1575.74,1174.53 1575.74,1181.64  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#AAAAAA"
    },
    points: " 387.11,1176.96 387.11,1169.69 1575.74,1169.69 1575.74,1176.96  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A9A9A9"
    },
    points: " 387.11,1172.11 387.11,1164.84 1575.74,1164.84 1575.74,1172.11  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A7A7A7"
    },
    points: " 387.11,1167.26 387.11,1160.15 1575.74,1160.15 1575.74,1167.26  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A6A6A6"
    },
    points: " 387.11,1162.58 387.11,1155.3 1575.74,1155.3 1575.74,1162.58  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A5A5A5"
    },
    points: " 387.11,1157.73 387.11,1150.46 1575.74,1150.46 1575.74,1157.73  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A4A4A4"
    },
    points: " 387.11,1152.88 387.11,1145.77 1575.74,1145.77 1575.74,1152.88  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A3A3A3"
    },
    points: " 387.11,1148.2 387.11,1140.93 1575.74,1140.93 1575.74,1148.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A2A2A2"
    },
    points: " 387.11,1143.35 387.11,1136.08 1575.74,1136.08 1575.74,1143.35  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#A0A0A0"
    },
    points: " 387.11,1138.51 387.11,1131.39 1575.74,1131.39 1575.74,1138.51  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9F9F9F"
    },
    points: " 387.11,1133.82 387.11,1126.55 1575.74,1126.55 1575.74,1133.82  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9E9E9E"
    },
    points: " 387.11,1128.97 387.11,1121.7 1575.74,1121.7 1575.74,1128.97  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9D9D9D"
    },
    points: " 387.11,1124.12 387.11,1117.02 1575.74,1117.02 1575.74,1124.12  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9C9C9C"
    },
    points: " 387.11,1119.44 387.11,1112.17 1575.74,1112.17 1575.74,1119.44  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9A9A9A"
    },
    points: " 387.11,1114.59 387.11,1107.32 1575.74,1107.32 1575.74,1114.59  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#999999"
    },
    points: " 387.11,1109.75 387.11,1102.64 1575.74,1102.64 1575.74,1109.75  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#989898"
    },
    points: " 387.11,1105.06 387.11,1097.79 1575.74,1097.79 1575.74,1105.06  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#979797"
    },
    points: " 387.11,1100.21 387.11,1092.94 1575.74,1092.94 1575.74,1100.21  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#969696"
    },
    points: " 387.11,1095.36 387.11,1088.26 1575.74,1088.26 1575.74,1095.36  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#959595"
    },
    points: " 387.11,1090.52 387.11,1083.41 1575.74,1083.41 1575.74,1090.52  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#939393"
    },
    points: " 387.11,1085.83 387.11,1078.56 1575.74,1078.56 1575.74,1085.83  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#929292"
    },
    points: " 387.11,1080.99 387.11,1073.88 1575.74,1073.88 1575.74,1080.99  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#919191"
    },
    points: " 387.11,1076.14 387.11,1069.03 1575.74,1069.03 1575.74,1076.14  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#909090"
    },
    points: " 387.11,1071.45 387.11,1064.18 1575.74,1064.18 1575.74,1071.45  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#8F8F8F"
    },
    points: " 387.11,1066.61 387.11,1059.5 1575.74,1059.5 1575.74,1066.61  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#8E8E8E"
    },
    points: " 387.11,1061.76 387.11,1054.65 1575.74,1054.65 1575.74,1061.76  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#8C8C8C"
    },
    points: " 387.11,1057.07 387.11,1049.8 1575.74,1049.8 1575.74,1057.07  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#8B8B8B"
    },
    points: " 387.11,1052.23 387.11,1045.12 1575.74,1045.12 1575.74,1052.23  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#8A8A8A"
    },
    points: " 387.11,1047.38 387.11,1040.27 1575.74,1040.27 1575.74,1047.38  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#898989"
    },
    points: " 387.11,1042.7 387.11,1035.42 1575.74,1035.42 1575.74,1042.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#888888"
    },
    points: " 387.11,1037.85 387.11,1030.74 1575.74,1030.74 1575.74,1037.85  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#868686"
    },
    points: " 387.11,1033 387.11,1025.89 1575.74,1025.89 1575.74,1033  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#858585"
    },
    points: " 387.11,1028.31 387.11,1021.05 1575.74,1021.05 1575.74,1028.31  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#848484"
    },
    points: " 387.11,1023.47 387.11,1016.36 1575.74,1016.36 1575.74,1023.47  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#838383"
    },
    points: " 387.11,1018.62 387.11,1011.51 1575.74,1011.51 1575.74,1018.62  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#828282"
    },
    points: " 387.11,1013.94 387.11,1006.67 1575.74,1006.67 1575.74,1013.94  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#818181"
    },
    points: " 387.11,1009.09 387.11,1001.98 1575.74,1001.98 1575.74,1009.09  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#808080"
    },
    points: " 387.11,1004.24 387.11,997.13 1575.74,997.13 1575.74,1004.24  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7F7F7F"
    },
    points: " 387.11,999.55 387.11,992.29 1575.74,992.29 1575.74,999.55  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7F7F7F"
    },
    points: " 387.11,994.71 387.11,987.6 1575.74,987.6 1575.74,994.71  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7F7F7F"
    },
    points: " 387.11,989.86 387.11,982.76 1575.74,982.76 1575.74,989.86  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7E7E7E"
    },
    points: " 387.11,985.18 387.11,977.91 1575.74,977.91 1575.74,985.18  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7E7E7E"
    },
    points: " 387.11,980.33 387.11,973.22 1575.74,973.22 1575.74,980.33  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7D7D7D"
    },
    points: " 387.11,975.48 387.11,968.38 1575.74,968.38 1575.74,975.48  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7D7D7D"
    },
    points: " 387.11,970.8 387.11,963.53 1575.74,963.53 1575.74,970.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7D7D7D"
    },
    points: " 387.11,965.95 387.11,958.85 1575.74,958.85 1575.74,965.95  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7C7C7C"
    },
    points: " 387.11,961.11 387.11,954 1575.74,954 1575.74,961.11  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7C7C7C"
    },
    points: " 387.11,956.42 387.11,949.15 1575.74,949.15 1575.74,956.42  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7B7B7B"
    },
    points: " 387.11,951.57 387.11,944.46 1575.74,944.46 1575.74,951.57  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7B7B7B"
    },
    points: " 387.11,946.73 387.11,939.62 1575.74,939.62 1575.74,946.73  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7B7B7B"
    },
    points: " 387.11,942.04 387.11,934.77 1575.74,934.77 1575.74,942.04  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7A7A7A"
    },
    points: " 387.11,937.19 387.11,930.09 1575.74,930.09 1575.74,937.19  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#7A7A7A"
    },
    points: " 387.11,932.35 387.11,925.24 1575.74,925.24 1575.74,932.35  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#797979"
    },
    points: " 387.11,927.66 387.11,920.39 1575.74,920.39 1575.74,927.66  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#797979"
    },
    points: " 387.11,922.82 387.11,915.71 1575.74,915.71 1575.74,922.82  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#797979"
    },
    points: " 387.11,917.97 387.11,910.86 1575.74,910.86 1575.74,917.97  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#787878"
    },
    points: " 387.11,913.28 387.11,906.01 1575.74,906.01 1575.74,913.28  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#787878"
    },
    points: " 387.11,908.44 387.11,901.33 1575.74,901.33 1575.74,908.44  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#777777"
    },
    points: " 387.11,903.59 387.11,896.48 1575.74,896.48 1575.74,903.59  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#777777"
    },
    points: " 387.11,898.9 387.11,891.63 1575.74,891.63 1575.74,898.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#777777"
    },
    points: " 387.11,894.06 387.11,886.95 1575.74,886.95 1575.74,894.06  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#767676"
    },
    points: " 387.11,889.21 387.11,882.1 1575.74,882.1 1575.74,889.21  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#767676"
    },
    points: " 387.11,884.52 387.11,877.25 1575.74,877.25 1575.74,884.52  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#757575"
    },
    points: " 387.11,879.68 387.11,872.57 1575.74,872.57 1575.74,879.68  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#757575"
    },
    points: " 387.11,874.83 387.11,867.72 1575.74,867.72 1575.74,874.83  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#757575"
    },
    points: " 387.11,870.14 387.11,862.88 1575.74,862.88 1575.74,870.14  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#747474"
    },
    points: " 387.11,865.3 387.11,858.19 1575.74,858.19 1575.74,865.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#747474"
    },
    points: " 387.11,860.45 387.11,853.34 1575.74,853.34 1575.74,860.45  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#737373"
    },
    points: " 387.11,855.77 387.11,848.5 1575.74,848.5 1575.74,855.77  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#737373"
    },
    points: " 387.11,850.92 387.11,843.81 1575.74,843.81 1575.74,850.92  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#737373"
    },
    points: " 387.11,846.07 387.11,838.96 1575.74,838.96 1575.74,846.07  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727272"
    },
    points: " 387.11,841.39 387.11,834.12 1575.74,834.12 1575.74,841.39  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#727272"
    },
    points: " 387.11,836.54 387.11,829.43 1575.74,829.43 1575.74,836.54  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#717171"
    },
    points: " 387.11,831.69 387.11,824.58 1575.74,824.58 1575.74,831.69  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#717171"
    },
    points: " 387.11,827.01 387.11,819.74 1575.74,819.74 1575.74,827.01  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#717171"
    },
    points: " 387.11,822.16 387.11,814.89 1575.74,814.89 1575.74,822.16  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#707070"
    },
    points: " 387.11,817.31 387.11,810.2 1575.74,810.2 1575.74,817.31  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#707070"
    },
    points: " 387.11,812.63 387.11,805.36 1575.74,805.36 1575.74,812.63  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6F6F6F"
    },
    points: " 387.11,807.78 387.11,800.51 1575.74,800.51 1575.74,807.78  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6F6F6F"
    },
    points: " 387.11,802.93 387.11,795.83 1575.74,795.83 1575.74,802.93  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6F6F6F"
    },
    points: " 387.11,798.25 387.11,790.98 1575.74,790.98 1575.74,798.25  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6E6E6E"
    },
    points: " 387.11,793.4 387.11,786.13 1575.74,786.13 1575.74,793.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6E6E6E"
    },
    points: " 387.11,788.55 387.11,781.45 1575.74,781.45 1575.74,788.55  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6D6D6D"
    },
    points: " 387.11,783.87 387.11,776.6 1575.74,776.6 1575.74,783.87  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6D6D6D"
    },
    points: " 387.11,779.02 387.11,771.75 1575.74,771.75 1575.74,779.02  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6D6D6D"
    },
    points: " 387.11,774.17 387.11,767.07 1575.74,767.07 1575.74,774.17  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6C6C6C"
    },
    points: " 387.11,769.49 387.11,762.22 1575.74,762.22 1575.74,769.49  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6C6C6C"
    },
    points: " 387.11,764.64 387.11,757.37 1575.74,757.37 1575.74,764.64  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6B6B6B"
    },
    points: " 387.11,759.8 387.11,752.69 1575.74,752.69 1575.74,759.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6B6B6B"
    },
    points: " 387.11,755.11 387.11,747.84 1575.74,747.84 1575.74,755.11  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6B6B6B"
    },
    points: " 387.11,750.26 387.11,742.99 1575.74,742.99 1575.74,750.26  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6A6A6A"
    },
    points: " 387.11,745.42 387.11,738.31 1575.74,738.31 1575.74,745.42  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#6A6A6A"
    },
    points: " 387.11,740.73 387.11,733.46 1575.74,733.46 1575.74,740.73  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#696969"
    },
    points: " 387.11,735.89 387.11,728.61 1575.74,728.61 1575.74,735.89  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#696969"
    },
    points: " 387.11,731.04 387.11,723.93 1575.74,723.93 1575.74,731.04  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#696969"
    },
    points: " 387.11,726.35 387.11,719.08 1575.74,719.08 1575.74,726.35  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#686868"
    },
    points: " 387.11,721.51 387.11,714.23 1575.74,714.23 1575.74,721.51  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#686868"
    },
    points: " 387.11,716.66 387.11,709.55 1575.74,709.55 1575.74,716.66  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#676767"
    },
    points: " 387.11,711.97 387.11,704.71 1575.74,704.71 1575.74,711.97  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#676767"
    },
    points: " 387.11,707.13 387.11,699.86 1575.74,699.86 1575.74,707.13  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#676767"
    },
    points: " 387.11,702.28 387.11,695.17 1575.74,695.17 1575.74,702.28  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#666666"
    },
    points: " 387.11,697.6 387.11,690.32 1575.74,690.32 1575.74,697.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#666666"
    },
    points: " 387.11,692.75 387.11,685.48 1575.74,685.48 1575.74,692.75  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#656565"
    },
    points: " 387.11,687.9 387.11,680.79 1575.74,680.79 1575.74,687.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#656565"
    },
    points: " 387.11,683.22 387.11,675.95 1575.74,675.95 1575.74,683.22  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#656565"
    },
    points: " 387.11,678.37 387.11,671.1 1575.74,671.1 1575.74,678.37  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#646464"
    },
    points: " 387.11,673.52 387.11,666.41 1575.74,666.41 1575.74,673.52  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#646464"
    },
    points: " 387.11,668.84 387.11,661.57 1575.74,661.57 1575.74,668.84  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#636363"
    },
    points: " 387.11,663.99 387.11,656.72 1575.74,656.72 1575.74,663.99  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#636363"
    },
    points: " 387.11,659.14 387.11,652.03 1575.74,652.03 1575.74,659.14  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#636363"
    },
    points: " 387.11,654.45 387.11,647.19 1575.74,647.19 1575.74,654.45  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#626262"
    },
    points: " 387.11,649.61 387.11,642.34 1575.74,642.34 1575.74,649.61  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#626262"
    },
    points: " 387.11,644.76 387.11,637.65 1575.74,637.65 1575.74,644.76  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#616161"
    },
    points: " 387.11,640.08 387.11,632.81 1575.74,632.81 1575.74,640.08  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#616161"
    },
    points: " 387.11,635.23 387.11,627.96 1575.74,627.96 1575.74,635.23  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#616161"
    },
    points: " 387.11,630.38 387.11,623.27 1575.74,623.27 1575.74,630.38  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#606060"
    },
    points: " 387.11,625.7 387.11,618.43 1575.74,618.43 1575.74,625.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#606060"
    },
    points: " 387.11,620.85 387.11,613.58 1575.74,613.58 1575.74,620.85  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5F5F5F"
    },
    points: " 387.11,616 387.11,608.9 1575.74,608.9 1575.74,616  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5F5F5F"
    },
    points: " 387.11,611.32 387.11,604.05 1575.74,604.05 1575.74,611.32  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5F5F5F"
    },
    points: " 387.11,606.47 387.11,599.2 1575.74,599.2 1575.74,606.47  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5E5E5E"
    },
    points: " 387.11,601.63 387.11,594.52 1575.74,594.52 1575.74,601.63  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5E5E5E"
    },
    points: " 387.11,596.94 387.11,589.67 1575.74,589.67 1575.74,596.94  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5D5D5D"
    },
    points: " 387.11,592.09 387.11,584.82 1575.74,584.82 1575.74,592.09  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5D5D5D"
    },
    points: " 387.11,587.25 387.11,580.14 1575.74,580.14 1575.74,587.25  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5D5D5D"
    },
    points: " 387.11,582.56 387.11,575.29 1575.74,575.29 1575.74,582.56  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5C5C5C"
    },
    points: " 387.11,577.71 387.11,570.44 1575.74,570.44 1575.74,577.71  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5C5C5C"
    },
    points: " 387.11,572.87 387.11,565.76 1575.74,565.76 1575.74,572.87  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5B5B5B"
    },
    points: " 387.11,568.18 387.11,560.91 1575.74,560.91 1575.74,568.18  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5B5B5B"
    },
    points: " 387.11,563.33 387.11,556.06 1575.74,556.06 1575.74,563.33  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5B5B5B"
    },
    points: " 387.11,558.49 387.11,551.38 1575.74,551.38 1575.74,558.49  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5A5A5A"
    },
    points: " 387.11,553.8 387.11,546.53 1575.74,546.53 1575.74,553.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5A5A5A"
    },
    points: " 387.11,548.96 387.11,541.68 1575.74,541.68 1575.74,548.96  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#595959"
    },
    points: " 387.11,544.11 387.11,537 1575.74,537 1575.74,544.11  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#595959"
    },
    points: " 387.11,539.42 387.11,532.15 1575.74,532.15 1575.74,539.42  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#595959"
    },
    points: " 387.11,534.58 387.11,527.3 1575.74,527.3 1575.74,534.58  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#585858"
    },
    points: " 387.11,529.73 387.11,522.62 1575.74,522.62 1575.74,529.73  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#585858"
    },
    points: " 387.11,524.88 387.11,517.78 1575.74,517.78 1575.74,524.88  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#575757"
    },
    points: " 387.11,520.2 387.11,512.93 1575.74,512.93 1575.74,520.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#575757"
    },
    points: " 387.11,515.35 387.11,508.24 1575.74,508.24 1575.74,515.35  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#575757"
    },
    points: " 387.11,510.5 387.11,503.39 1575.74,503.39 1575.74,510.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#565656"
    },
    points: " 387.11,505.82 387.11,498.55 1575.74,498.55 1575.74,505.82  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#565656"
    },
    points: " 387.11,500.97 387.11,493.86 1575.74,493.86 1575.74,500.97  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#555555"
    },
    points: " 387.11,496.12 387.11,489.02 1575.74,489.02 1575.74,496.12  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#555555"
    },
    points: " 387.11,491.44 387.11,484.17 1575.74,484.17 1575.74,491.44  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#555555"
    },
    points: " 387.11,486.59 387.11,479.48 1575.74,479.48 1575.74,486.59  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#545454"
    },
    points: " 387.11,481.75 387.11,474.64 1575.74,474.64 1575.74,481.75  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#545454"
    },
    points: " 387.11,477.06 387.11,469.79 1575.74,469.79 1575.74,477.06  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#535353"
    },
    points: " 387.11,472.21 387.11,465.1 1575.74,465.1 1575.74,472.21  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#535353"
    },
    points: " 387.11,467.36 387.11,460.26 1575.74,460.26 1575.74,467.36  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#535353"
    },
    points: " 387.11,462.68 387.11,455.41 1575.74,455.41 1575.74,462.68  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#525252"
    },
    points: " 387.11,457.84 387.11,450.72 1575.74,450.72 1575.74,457.84  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#525252"
    },
    points: " 387.11,452.99 387.11,445.88 1575.74,445.88 1575.74,452.99  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#515151"
    },
    points: " 387.11,448.3 387.11,441.03 1575.74,441.03 1575.74,448.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#515151"
    },
    points: " 387.11,443.46 387.11,436.34 1575.74,436.34 1575.74,443.46  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#515151"
    },
    points: " 387.11,438.61 387.11,431.5 1575.74,431.5 1575.74,438.61  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#505050"
    },
    points: " 387.11,433.92 387.11,426.65 1575.74,426.65 1575.74,433.92  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#505050"
    },
    points: " 387.11,429.07 387.11,421.97 1575.74,421.97 1575.74,429.07  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4F4F4F"
    },
    points: " 387.11,424.23 387.11,417.12 1575.74,417.12 1575.74,424.23  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4F4F4F"
    },
    points: " 387.11,419.54 387.11,412.27 1575.74,412.27 1575.74,419.54  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4F4F4F"
    },
    points: " 387.11,414.69 387.11,407.59 1575.74,407.59 1575.74,414.69  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4E4E4E"
    },
    points: " 387.11,409.85 387.11,402.74 1575.74,402.74 1575.74,409.85  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4E4E4E"
    },
    points: " 387.11,405.16 387.11,397.89 1575.74,397.89 1575.74,405.16  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4D4D4D"
    },
    points: " 387.11,400.32 387.11,393.21 1575.74,393.21 1575.74,400.32  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000127744662488414375050000005796373460177791415_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4D4D4D"
    },
    points: " 387.11,395.47 387.11,385.94 1575.74,385.94 1575.74,395.47  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st532",
    d: "M1429.36,718.92l-284.35,280.63l41.68,41.04l242.67,239.44l73.35,72.38l73.03,72.06 c-20.68,27.79-43.3,54.12-67.7,78.68c-129.57,130.54-308.91,211.33-507.31,211.33c-126.18,0-244.77-32.79-347.68-90.15 c-29.73-16.48-58-35.06-84.98-55.58L420.4,1714.48H276.12H131.84l293.88-290.01c-16.96-22.94-32.63-47.02-46.85-72.06 c-59.3-104.05-93.06-224.57-93.06-352.86c0-394.86,320.06-714.92,714.92-714.92c145.41,0,280.64,43.3,393.41,117.94 c13.41,8.89,26.49,18.1,39.26,27.79l147.67-145.73h144.28h144.27l-293.88,290.01l-73.03,71.9L1429.36,718.92z M1059.06,1199.58 l-58.33-57.68l-286.29,282.42c33.12,22.46,68.99,41.04,107.12,55.26c55.74,20.84,116.16,32.15,179.17,32.15 c105.99,0,204.54-32.15,286.3-87.4L1059.06,1199.58z M802.49,1413l198.24-195.49L1198.97,1413 c-61.55,29.57-129.09,44.91-198.24,44.91c-54.77,0-109.05-9.53-160.43-28.75C827.54,1424.31,814.77,1418.98,802.49,1413L802.49,1413 z M856.46,999.55L572.1,718.92h144.28h144.28l140.07,138.3l286.3-282.58c-12.6-8.4-25.53-16.32-38.94-23.75 c-73.35-40.55-157.69-63.66-247.36-63.66c-179.33,0-337.18,92.25-428.63,231.68c-52.83,80.62-83.69,177.08-83.69,280.63 c0,76.91,16.97,149.93,47.5,215.37c10.5,22.62,22.62,44.43,36.19,65.11L856.46,999.55z M779.88,999.55l-195.33,192.58 c-28.11-60.43-42.33-126.01-42.33-192.58c0-67.05,14.54-132.64,42.33-192.74L779.88,999.55z M686.98,665.12 c83.85-78.84,195.49-124.08,313.75-124.08c68.83,0,136.36,15.35,198.24,44.92l-198.24,195.66l-118.1-116.49H686.98z M0.65,1768.28 h441.72l131.35-129.58c17.29,11.63,35.06,22.46,53.15,32.64c114.55,63.82,242.67,96.94,373.86,96.94 c205.51,0,400.68-81.43,545.44-227.16c26.33-26.49,50.57-54.77,72.7-84.66l27.79-37.48l-425.08-419.42l779.06-768.72h-441.72 l-131.19,129.41l-3.87-2.59c-125.86-83.04-272.4-126.83-423.14-126.83c-424.59,0-768.72,344.13-768.72,768.72 c0,133.3,34.09,263.51,100.01,379.52c7.6,13.09,15.51,26.18,23.75,38.78L0.65,1768.28z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c02725c5f251fe3f4b448f6c5d0899c1.svg";
export { ForwardRef as ReactComponent };